import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import PaginatedSortableTable from "../components/PaginatedSortableTable";
import AgentTree from "../components/AgentTree";
import $ from "jquery";
import "jstree";
import "jstree/dist/themes/default/style.css";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export default function AgentInfo() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const today = new Date();
  const formatDate = (date) => date.toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(formatDate(today));
  const [endDate, setEndDate] = useState(formatDate(today));
  const { setIsLoggedIn } = useOutletContext();
  const navigate = useNavigate();
  const { state } = useLocation();
  const user = state?.user;

  return (
    <div className="nk-content">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block nk-block-lg vPartnerDetail">
              <div className="card card-bordered card-stretch">
                <div className="card-inner user-view-box">
                  <div className="row g-gs">
                    <div className="col-sm-12 col-lg-5 col-xxl-5">
                      <div className="nk-block-head nk-block-head-sm">
                        <div className="nk-block-head-content">
                          <h3 className="nk-block-title page-title">
                            {user.user_id}
                            <strong
                              className="text-primary small ms-2"
                              data-bs-original-title="보유금"
                              data-bs-toggle="tooltip"
                              data-placement="top"
                            >
                              <em className="icon-ccash">
                                <img src="./images/icons/icon-ccoin.png" />
                              </em>
                              <span>{user.possess_amt.toLocaleString()}</span>
                            </strong>
                          </h3>
                          <div className="nk-block-des text-soft">
                            <ul className="list-inline">
                              <li>
                                {" "}
                                #Prefix :{" "}
                                <span className="text-base">{user.prefix}</span>
                              </li>
                              <li>
                                아이디 :{" "}
                                <span className="text-base">
                                  {user.user_id}
                                </span>
                              </li>
                              <li>
                                <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                  S
                                </em>
                              </li>
                              <li>
                                <span>
                                  <em
                                    className={`badge me-1 ${
                                      user.auth_level == 0
                                        ? "super"
                                        : "M" + user.auth_level
                                    }`}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    {user.user_id}
                                  </em>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-7 col-xxl-7">
                      <div className="card card-bordered card-full">
                        <div className="row">
                          <div className="col-2 p-1 ps-4 pt-2">
                            <h6>통합알</h6>
                          </div>
                          <div className="col-3 p-1">
                            <div className="title">회원 보유금</div>
                            <div className="amount">
                              <span>0</span>
                              <span className="ps-1 currency-usd">KRW</span>
                            </div>
                          </div>
                          <div className="col-3 p-1">
                            <div className="title">에이전트 보유금</div>
                            <div className="amount">
                              <span>{user.possess_amt.toLocaleString()}</span>
                              <span className="ps-1 currency-usd">KRW</span>
                            </div>
                          </div>
                          <div className="col-3 p-1">
                            <div className="title">총 보유금</div>
                            <div className="amount">
                              <strong>
                                <span>{user.possess_amt.toLocaleString()}</span>
                                <span className="ps-1 currency-usd">KRW</span>
                              </strong>
                            </div>
                          </div>
                        </div>
                        <div
                          className="invest-data-history totalCash p-1"
                          style={{
                            textAlign: "right",
                          }}
                        >
                          <div className="custom-control switch-onoff custom-switch ms-2">
                            <input
                              className="custom-control-input"
                              id="sw-treeAllSelect"
                              type="checkbox"
                            />
                            <label
                              className="custom-control-label text-nowrap"
                              htmlFor="sw-treeAllSelect"
                            >
                              {/* TODO */}
                              <strong>하부포함</strong>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row g-gs pt-2">
                    <div className="col-sm-12 col-lg-12 col-xxl-12">
                      <div className="nk-block-head-content">
                        <div className="btn-group nav nav-tabs" role="tablist">
                          <button
                            className="btn btn-dim btn-outline-primary active"
                            data-bs-toggle="tab"
                            href="#tb_report"
                            id="report"
                            type="button"
                          >
                            <em className="icon ni ni-reports d-none d-sm-inline-flex" />{" "}
                            보고서
                          </button>
                          <button
                            className="btn btn-dim btn-outline-primary"
                            data-bs-toggle="tab"
                            href="#tb_userlist"
                            id="users"
                            type="button"
                          >
                            <em className="icon ni ni-user-list d-none d-sm-inline-flex" />{" "}
                            회원목록
                          </button>

                          <button
                            className="btn btn-dim btn-outline-primary"
                            data-bs-toggle="tab"
                            href="#tb_agent"
                            id="users"
                            type="button"
                          >
                            <em className="icon ni ni-user-list d-none d-sm-inline-flex" />{" "}
                            하부 에이전트
                          </button>
                          <button
                            className="btn btn-dim btn-outline-primary"
                            data-bs-toggle="tab"
                            href="#tb_transaction"
                            id="trxs"
                            type="button"
                          >
                            <em className="icon ni ni-tranx d-none d-sm-inline-flex" />
                            전체거래
                          </button>
                          <button
                            className="btn btn-dim btn-outline-primary"
                            data-bs-toggle="tab"
                            href="#tb_bet"
                            id="bet"
                            type="button"
                          >
                            <em className="icon ni ni-tranx d-none d-sm-inline-flex" />{" "}
                            베팅내역
                          </button>
                          <button
                            className="btn btn-dim btn-outline-primary"
                            data-bs-toggle="tab"
                            href="#settings"
                            id="config"
                            type="button"
                          >
                            <em className="icon ni ni-setting-fill d-none d-sm-inline-flex" />{" "}
                            환경설정
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="-accordion" id="accordion-dboard">
              <div
                className="accordion-body mt-4 collapse show"
                id="accordion-item-ik"
              >
                <div className="nk-block">
                  <div className="row g-gs">
                    <div
                      className="col-sm-12 col-lg-6 col-xxl-3"
                      usertype="user"
                    >
                      <div className="card card-bordered h-100">
                        <div className="card-inner h-100 stretch flex-column">
                          <div className="team">
                            <table className="table table-small-font table-tighten table-bordered">
                              <thead>
                                <tr>
                                  <th className="text-center">트리정보</th>
                                  <th className="text-center">정보</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="text-center vam px-2">
                                    <span>
                                      <em
                                        className="badge me-1 super"
                                        style={{
                                          cursor: "pointer",
                                        }}
                                      >
                                        {/* TODO */}
                                        Matrixgames
                                      </em>
                                    </span>
                                  </td>
                                  <td className="text-center vam px-2">
                                    <h6 className="fs-6 mb-0">
                                      {user.user_id}
                                    </h6>
                                    <span className="sub-text">
                                      {user.user_id}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div className="user-card user-card-s2 table-responsive" />
                            <ul className="team-info">
                              <li className="text-center" />
                              <li>
                                <span>지갑 / Prefix</span>
                                <span>
                                  <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                    S
                                  </em>{" "}
                                  / {user.prefix}
                                </span>
                              </li>
                              <li>
                                <span>통화 / 상태</span>
                                <span>
                                  KRW /{" "}
                                  <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                    정상
                                  </span>
                                </span>
                              </li>
                              <li>
                                <span>가입일</span>
                                <span>
                                  <span
                                    style={{
                                      fontSize: "95%",
                                    }}
                                  >
                                    {dayjs
                                      .utc(user.reg_dt)
                                      .tz("Asia/Seoul")
                                      .format("YYYY-MM-DD (HH:mm:ss [UTC +9])")}
                                  </span>
                                </span>
                              </li>
                              <li>
                                <span>수정일</span>
                                <span>
                                  <span
                                    style={{
                                      fontSize: "95%",
                                    }}
                                  >
                                    {dayjs
                                      .utc(user.mod_dt)
                                      .tz("Asia/Seoul")
                                      .format("YYYY-MM-DD (HH:mm:ss [UTC +9])")}
                                  </span>
                                </span>
                              </li>
                              <li>
                                <span>접속일</span>
                                <span>
                                  <span
                                    style={{
                                      fontSize: "95%",
                                    }}
                                  />
                                  {dayjs
                                    .utc(user.last_dt)
                                    .tz("Asia/Seoul")
                                    .format("YYYY-MM-DD (HH:mm:ss [UTC +9])")}
                                </span>
                              </li>
                              <li>
                                <div className="input-group">
                                  <textarea
                                    className="form-control"
                                    disabled
                                    style={{
                                      minHeight: "35px",
                                    }}
                                  />
                                </div>
                              </li>
                            </ul>
                            <div className="team-view">
                              <button
                                className="btn btn-sm btn-block btn-dim btn-primary"
                                type="button"
                              >
                                정보 수정
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6 col-xxl-3">
                      <div className="card card-bordered card-full">
                        <div className="card-inner">
                          <div className="card-title-group mb-1">
                            <div className="card-title">
                              <h6 className="title">
                                <em className="icon ni ni-calendar-booking-fill" />{" "}
                                베팅내역
                              </h6>
                            </div>
                          </div>
                          <ul
                            className="nav nav-tabs nav-tabs-card nav-tabs-xs"
                            style={{
                              display: "none",
                            }}
                          >
                            <li className="nav-item">
                              <a
                                className="nav-link active"
                                data-bs-toggle="tab"
                                href="#overview"
                              >
                                오늘
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#yday"
                              >
                                어제
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#thismonth"
                              >
                                이번달
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content mt-0">
                            <div className="tab-pane" id="overview">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>2025-05-06(오늘)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>0</span> ( 0 % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane active" id="yday">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>2025-05-05 (어제)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>0</span> ( 0 % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane" id="thismonth">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>2025-05 (이번달)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>0</span> ( 0 % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6 col-xxl-3">
                      <div className="card card-bordered card-full">
                        <div className="card-inner">
                          <div className="card-title-group mb-1">
                            <div className="card-title">
                              <h6 className="title">
                                <em className="icon ni ni-calendar-booking-fill" />{" "}
                                베팅내역
                              </h6>
                            </div>
                          </div>
                          <ul
                            className="nav nav-tabs nav-tabs-card nav-tabs-xs"
                            style={{
                              display: "none",
                            }}
                          >
                            <li className="nav-item">
                              <a
                                className="nav-link active"
                                data-bs-toggle="tab"
                                href="#overview"
                              >
                                오늘
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#yday"
                              >
                                어제
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#thismonth"
                              >
                                이번달
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content mt-0">
                            <div className="tab-pane active" id="overview">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>2025-05-06(오늘)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>0</span> ( 0 % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane" id="yday">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>2025-05-05 (어제)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>0</span> ( 0 % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane" id="thismonth">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>2025-05 (이번달)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>0</span> ( 0 % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6 col-xxl-3">
                      <div className="card card-bordered card-full">
                        <div className="card-inner">
                          <div className="card-title-group mb-1">
                            <div className="card-title">
                              <h6 className="title">
                                <em className="icon ni ni-calendar-booking-fill" />{" "}
                                베팅내역
                              </h6>
                            </div>
                          </div>
                          <ul
                            className="nav nav-tabs nav-tabs-card nav-tabs-xs"
                            style={{
                              display: "none",
                            }}
                          >
                            <li className="nav-item">
                              <a
                                className="nav-link active"
                                data-bs-toggle="tab"
                                href="#overview"
                              >
                                오늘
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#yday"
                              >
                                어제
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#thismonth"
                              >
                                이번달
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content mt-0">
                            <div className="tab-pane" id="overview">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>2025-05-06(오늘)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>0</span> ( 0 % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane" id="yday">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>2025-05-05 (어제)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>0</span> ( 0 % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane active" id="thismonth">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>2025-05 (이번달)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>0</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>0</span> ( 0 % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nk-block nk-block-lg pt-4">
              <div className="card card-bordered">
                <div className="tab-content">
                  <div className="tab-pane show active" id="tb_report">
                    <ul className="nav nav-tabs nav-tabs-card">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          href="#tabintab02"
                        >
                          <span>
                            <i className="ni ni-calendar-alt-fill" />
                            일별 정산
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#tabintab03"
                        >
                          <span>
                            <i className="ni ni-calendar-booking-fill" />
                            월별 정산
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#tabintab01"
                        >
                          <span>
                            <em className="ni ni-swap-alt" /> 에이전트 지급/회수
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#tabintab04"
                        >
                          <span>
                            <em className="ni ni-swap-alt-fill" /> 회원 수동
                            지급/회수
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div className="tab-pane active" id="tabintab02">
                        <div className="nk-block">
                          <div className="card">
                            <div className="card-inner-group">
                              <div className="card-inner p-3 p-0">
                                <div className="nk-block nk-block-lg">
                                  <div className="row tbSearch">
                                    <div className="col-12 col-sm-12" />
                                    <div className="col-12 col-md-5 col-xl-5 col-xxl-5 offset-xxl-2">
                                      <div className="form-group">
                                        <div className="form-control-wrap raw">
                                          <div className="input-daterange input-group">
                                            <div className="form-control-wrap">
                                              <div className="form-icon form-icon-left">
                                                <em className="icon ni ni-calendar" />
                                              </div>
                                              <input
                                                className="form-control date-picker"
                                                data-date-format="yyyy-mm-dd"
                                                id="sdate"
                                                type="text"
                                              />
                                            </div>
                                            <div className="input-group-addon">
                                              ~
                                            </div>
                                            <div className="form-control-wrap">
                                              <div className="form-icon form-icon-left">
                                                <em className="icon ni ni-calendar" />
                                              </div>
                                              <input
                                                className="form-control date-picker"
                                                data-date-format="yyyy-mm-dd"
                                                id="edate"
                                                type="text"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-10 col-md-5 col-xl-5 col-xxl-4">
                                      <div className="form-group">
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Yesterday"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Yesterday"
                                          >
                                            어제
                                          </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Today"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Today"
                                          >
                                            오늘
                                          </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Week"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Week"
                                          >
                                            일주일
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-2 col-sm-2 col-xl-2 col-xxl-1">
                                      <div className="input-group withcontrol">
                                        <button className="btn btn-outline-primary btn-dim">
                                          <em className="icon ni ni-search me-1" />
                                          <font>검색</font>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="nk-files-group user-days">
                              <div
                                className="table-wrapper"
                                style={{
                                  borderTop: "1px dotted #BBB",
                                  paddingTop: "5px 0",
                                }}
                              >
                                <div className="btn-toolbar justify-content-between">
                                  <div className="btn-group focus-btn-group" />
                                  <div className="btn-group dropdown-btn-group dropdown">
                                    <button
                                      className="btn btn-sm btn-outline-primary"
                                      type="button"
                                    >
                                      모두 보기
                                    </button>
                                    <button
                                      className="btn btn-sm btn-outline-primary dropdown-toggle"
                                      data-bs-toggle="dropdown"
                                      id="displayMenuid6ab644ee1c6e78"
                                      type="button"
                                    >
                                      항목 선택{" "}
                                      <em className="icon ni ni-chevron-down ms-1 me-n1" />
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-0"
                                          id="toggle-id6ab644ee1c6e78-col-0"
                                          name="toggle-id6ab644ee1c6e78-col-0"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-0">
                                          게임사
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-1"
                                          id="toggle-id6ab644ee1c6e78-col-1"
                                          name="toggle-id6ab644ee1c6e78-col-1"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-1">
                                          화폐
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-2"
                                          id="toggle-id6ab644ee1c6e78-col-2"
                                          name="toggle-id6ab644ee1c6e78-col-2"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-2">
                                          베팅
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-3"
                                          id="toggle-id6ab644ee1c6e78-col-3"
                                          name="toggle-id6ab644ee1c6e78-col-3"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-3">
                                          승
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-4"
                                          id="toggle-id6ab644ee1c6e78-col-4"
                                          name="toggle-id6ab644ee1c6e78-col-4"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-4">
                                          무
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-5"
                                          id="toggle-id6ab644ee1c6e78-col-5"
                                          name="toggle-id6ab644ee1c6e78-col-5"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-5">
                                          취소
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-6"
                                          id="toggle-id6ab644ee1c6e78-col-6"
                                          name="toggle-id6ab644ee1c6e78-col-6"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-6">
                                          {" "}
                                          Win/Lose{" "}
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-7"
                                          id="toggle-id6ab644ee1c6e78-col-7"
                                          name="toggle-id6ab644ee1c6e78-col-7"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-7">
                                          {" "}
                                          RTP
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-8"
                                          id="toggle-id6ab644ee1c6e78-col-8"
                                          name="toggle-id6ab644ee1c6e78-col-8"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-8">
                                          초과 당첨금
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-9"
                                          id="toggle-id6ab644ee1c6e78-col-9"
                                          name="toggle-id6ab644ee1c6e78-col-9"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-9">
                                          베팅수
                                        </label>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div
                                  className="table-responsive"
                                  data-add-focus-btn="true"
                                  data-fixed-nav-bar="true"
                                  data-pattern="priority-columns"
                                  data-sortable="true"
                                >
                                  <table
                                    cellSpacing="0"
                                    className="table dataTable no-footer dtr-inline navbar-fixed-top"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          data-pos-x="0"
                                          id="id6ab644ee1c6e78-col-0"
                                        >
                                          <span className="sub-text text-center">
                                            게임사
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="1"
                                          id="id6ab644ee1c6e78-col-1"
                                        >
                                          <span className="sub-text text-center">
                                            화폐
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="2"
                                          id="id6ab644ee1c6e78-col-2"
                                        >
                                          <span className="sub-text text-center">
                                            베팅
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="3"
                                          id="id6ab644ee1c6e78-col-3"
                                        >
                                          <span className="sub-text text-center">
                                            승
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="4"
                                          id="id6ab644ee1c6e78-col-4"
                                        >
                                          <span className="sub-text text-center">
                                            무
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="5"
                                          id="id6ab644ee1c6e78-col-5"
                                        >
                                          <span className="sub-text text-center">
                                            취소
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="6"
                                          id="id6ab644ee1c6e78-col-6"
                                        >
                                          <span
                                            className="sub-text text-center"
                                            data-bs-original-title="베팅 - (승 + 무 + 취소)"
                                            data-bs-toggle="tooltip"
                                          >
                                            {" "}
                                            Win/Lose{" "}
                                            <em className="icon ni ni-info-fill vam" />
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="7"
                                          id="id6ab644ee1c6e78-col-7"
                                        >
                                          <span
                                            className="sub-text text-center"
                                            data-bs-original-title="승 + 무 + 취소 / 베팅 * 100"
                                            data-bs-toggle="tooltip"
                                          >
                                            {" "}
                                            RTP
                                            <em className="icon ni ni-info-fill vam" />
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="8"
                                          id="id6ab644ee1c6e78-col-8"
                                        >
                                          <span className="sub-text text-center">
                                            초과 당첨금
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="9"
                                          id="id6ab644ee1c6e78-col-9"
                                        >
                                          <span className="sub-text text-center">
                                            베팅수
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="casino">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-primary">
                                            CASINO
                                          </span>
                                          <a href="#">에볼루션 카지노</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="casino" data-pos-y="1">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-primary">
                                            CASINO
                                          </span>
                                          <a href="#">드림게이밍</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="casino" data-pos-y="2">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-primary">
                                            CASINO
                                          </span>
                                          <a href="#">아시안게이밍 카지노</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr
                                        className="casino total"
                                        data-pos-y="15"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          카지노 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="slot" data-pos-y="16">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                            SLOT
                                          </span>
                                          <a href="#">
                                            마이크로게이밍 그랜드 슬롯
                                          </a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="slot" data-pos-y="17">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                            SLOT
                                          </span>
                                          <a href="#">프라그마틱 슬롯</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="slot" data-pos-y="18">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                            SLOT
                                          </span>
                                          <a href="#">아시안게이밍 슬롯</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="slot" data-pos-y="56">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                            SLOT
                                          </span>
                                          <a href="#">와즈단</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr
                                        className="slot total"
                                        data-pos-y="57"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          슬롯게임 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr
                                        className="casino-hotel"
                                        data-pos-y="58"
                                      >
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-secondary">
                                            SPORTS
                                          </span>
                                          <a href="#">BT1</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr
                                        className="casino-hotel total"
                                        data-pos-y="59"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          스포츠 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                    </tbody>
                                    <tfoot className="dt_user_view_total">
                                      <tr>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          총합
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane" id="tabintab03">
                        <div className="nk-block">
                          <div className="card">
                            <div className="card-inner-group">
                              <div className="card-inner p-3 p-0">
                                <div className="nk-block nk-block-lg">
                                  <div className="row tbSearch">
                                    <div className="col-12 col-sm-12 col-xl-5" />
                                    <div className="col-12 col-md-6 offset-md-6">
                                      <div className="form-group withcontrol">
                                        <div className="form-control-wrap">
                                          <select className="form-select">
                                            <option checked value="2025">
                                              2025년
                                            </option>
                                            <option checked value="2024">
                                              2024년
                                            </option>
                                            <option checked value="2023">
                                              2023년
                                            </option>
                                          </select>
                                        </div>
                                        <div className="form-control-wrap">
                                          <select className="form-select">
                                            <option checked value="01">
                                              01월
                                            </option>
                                            <option checked value="02">
                                              02월
                                            </option>
                                            <option checked value="03">
                                              03월
                                            </option>
                                            <option checked value="04">
                                              04월
                                            </option>
                                            <option checked value="05">
                                              05월
                                            </option>
                                            <option checked value="06">
                                              06월
                                            </option>
                                            <option checked value="07">
                                              07월
                                            </option>
                                            <option checked value="08">
                                              08월
                                            </option>
                                            <option checked value="09">
                                              09월
                                            </option>
                                            <option checked value="10">
                                              10월
                                            </option>
                                            <option checked value="11">
                                              11월
                                            </option>
                                            <option checked value="12">
                                              12월
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="nk-files-group user-days">
                              <div
                                className="table-wrapper"
                                style={{
                                  borderTop: "1px dotted #BBB",
                                  paddingTop: "5px 0",
                                }}
                              >
                                <div className="btn-toolbar justify-content-between">
                                  <div className="btn-group focus-btn-group" />
                                  <div className="btn-group dropdown-btn-group dropdown">
                                    <button
                                      className="btn btn-sm btn-outline-primary"
                                      type="button"
                                    >
                                      모두 보기
                                    </button>
                                    <button
                                      className="btn btn-sm btn-outline-primary dropdown-toggle"
                                      data-bs-toggle="dropdown"
                                      id="displayMenuid6ab644ee1c6e78"
                                      type="button"
                                    >
                                      항목 선택{" "}
                                      <em className="icon ni ni-chevron-down ms-1 me-n1" />
                                    </button>
                                    <ul className="dropdown-menu">
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-0"
                                          id="toggle-id6ab644ee1c6e78-col-0"
                                          name="toggle-id6ab644ee1c6e78-col-0"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-0">
                                          게임사
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-1"
                                          id="toggle-id6ab644ee1c6e78-col-1"
                                          name="toggle-id6ab644ee1c6e78-col-1"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-1">
                                          화폐
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-2"
                                          id="toggle-id6ab644ee1c6e78-col-2"
                                          name="toggle-id6ab644ee1c6e78-col-2"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-2">
                                          베팅
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-3"
                                          id="toggle-id6ab644ee1c6e78-col-3"
                                          name="toggle-id6ab644ee1c6e78-col-3"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-3">
                                          승
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-4"
                                          id="toggle-id6ab644ee1c6e78-col-4"
                                          name="toggle-id6ab644ee1c6e78-col-4"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-4">
                                          무
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-5"
                                          id="toggle-id6ab644ee1c6e78-col-5"
                                          name="toggle-id6ab644ee1c6e78-col-5"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-5">
                                          취소
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-6"
                                          id="toggle-id6ab644ee1c6e78-col-6"
                                          name="toggle-id6ab644ee1c6e78-col-6"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-6">
                                          {" "}
                                          Win/Lose{" "}
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-7"
                                          id="toggle-id6ab644ee1c6e78-col-7"
                                          name="toggle-id6ab644ee1c6e78-col-7"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-7">
                                          {" "}
                                          RTP
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-8"
                                          id="toggle-id6ab644ee1c6e78-col-8"
                                          name="toggle-id6ab644ee1c6e78-col-8"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-8">
                                          초과 당첨금
                                        </label>
                                      </li>
                                      <li className="checkbox-row">
                                        <input
                                          defaultValue="id6ab644ee1c6e78-col-9"
                                          id="toggle-id6ab644ee1c6e78-col-9"
                                          name="toggle-id6ab644ee1c6e78-col-9"
                                          type="checkbox"
                                        />
                                        <label htmlFor="toggle-id6ab644ee1c6e78-col-9">
                                          베팅수
                                        </label>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div
                                  className="table-responsive"
                                  data-add-focus-btn="true"
                                  data-fixed-nav-bar="true"
                                  data-pattern="priority-columns"
                                  data-sortable="true"
                                >
                                  <table
                                    cellSpacing="0"
                                    className="table dataTable no-footer dtr-inline navbar-fixed-top"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          data-pos-x="0"
                                          id="id6ab644ee1c6e78-col-0"
                                        >
                                          <span className="sub-text text-center">
                                            게임사
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="1"
                                          id="id6ab644ee1c6e78-col-1"
                                        >
                                          <span className="sub-text text-center">
                                            화폐
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="2"
                                          id="id6ab644ee1c6e78-col-2"
                                        >
                                          <span className="sub-text text-center">
                                            베팅
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="3"
                                          id="id6ab644ee1c6e78-col-3"
                                        >
                                          <span className="sub-text text-center">
                                            승
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="4"
                                          id="id6ab644ee1c6e78-col-4"
                                        >
                                          <span className="sub-text text-center">
                                            무
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="5"
                                          id="id6ab644ee1c6e78-col-5"
                                        >
                                          <span className="sub-text text-center">
                                            취소
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="6"
                                          id="id6ab644ee1c6e78-col-6"
                                        >
                                          <span
                                            className="sub-text text-center"
                                            data-bs-original-title="베팅 - (승 + 무 + 취소)"
                                            data-bs-toggle="tooltip"
                                          >
                                            {" "}
                                            Win/Lose{" "}
                                            <em className="icon ni ni-info-fill vam" />
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="7"
                                          id="id6ab644ee1c6e78-col-7"
                                        >
                                          <span
                                            className="sub-text text-center"
                                            data-bs-original-title="승 + 무 + 취소 / 베팅 * 100"
                                            data-bs-toggle="tooltip"
                                          >
                                            {" "}
                                            RTP
                                            <em className="icon ni ni-info-fill vam" />
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="8"
                                          id="id6ab644ee1c6e78-col-8"
                                        >
                                          <span className="sub-text text-center">
                                            초과 당첨금
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="9"
                                          id="id6ab644ee1c6e78-col-9"
                                        >
                                          <span className="sub-text text-center">
                                            베팅수
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr className="casino">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-primary">
                                            CASINO
                                          </span>
                                          <a href="#">에볼루션 카지노</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="casino" data-pos-y="1">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-primary">
                                            CASINO
                                          </span>
                                          <a href="#">드림게이밍</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="casino" data-pos-y="2">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-primary">
                                            CASINO
                                          </span>
                                          <a href="#">아시안게이밍 카지노</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr
                                        className="casino total"
                                        data-pos-y="15"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          카지노 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="slot" data-pos-y="16">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                            SLOT
                                          </span>
                                          <a href="#">
                                            마이크로게이밍 그랜드 슬롯
                                          </a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="slot" data-pos-y="17">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                            SLOT
                                          </span>
                                          <a href="#">프라그마틱 슬롯</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="slot" data-pos-y="18">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                            SLOT
                                          </span>
                                          <a href="#">아시안게이밍 슬롯</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr className="slot" data-pos-y="56">
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                            SLOT
                                          </span>
                                          <a href="#">와즈단</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr
                                        className="slot total"
                                        data-pos-y="57"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          슬롯게임 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr
                                        className="casino-hotel"
                                        data-pos-y="58"
                                      >
                                        <td
                                          className="text-start"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span className="badge rounded-pill badge-dim bg-outline-secondary">
                                            SPORTS
                                          </span>
                                          <a href="#">BT1</a>
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                      <tr
                                        className="casino-hotel total"
                                        data-pos-y="59"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          스포츠 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                    </tbody>
                                    <tfoot className="dt_user_view_total">
                                      <tr>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          총합
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          0%
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>0</span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          0
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane" id="tabintab01">
                        <div className="nk-block">
                          <div className="card">
                            <div className="card-inner-group">
                              <div className="card-inner p-3 p-0">
                                <div className="nk-block nk-block-lg">
                                  <div className="row tbSearch">
                                    <div className="col-12 col-sm-12" />
                                    <div className="col-12 col-md-5 col-xl-5 col-xxl-5 offset-xxl-2">
                                      <div className="form-group">
                                        <div className="form-control-wrap raw">
                                          <div className="input-daterange input-group">
                                            <div className="form-control-wrap">
                                              <div className="form-icon form-icon-left">
                                                <em className="icon ni ni-calendar" />
                                              </div>
                                              <input
                                                className="form-control date-picker"
                                                data-date-format="yyyy-mm-dd"
                                                id="sdate"
                                                type="text"
                                              />
                                            </div>
                                            <div className="input-group-addon">
                                              ~
                                            </div>
                                            <div className="form-control-wrap">
                                              <div className="form-icon form-icon-left">
                                                <em className="icon ni ni-calendar" />
                                              </div>
                                              <input
                                                className="form-control date-picker"
                                                data-date-format="yyyy-mm-dd"
                                                id="edate"
                                                type="text"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-10 col-md-5 col-xl-5 col-xxl-4">
                                      <div className="form-group">
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Yesterday"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Yesterday"
                                          >
                                            어제
                                          </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Today"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Today"
                                          >
                                            오늘
                                          </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Week"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Week"
                                          >
                                            일주일
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-2 col-sm-2 col-xl-2 col-xxl-1">
                                      <div className="input-group withcontrol">
                                        <button className="btn btn-outline-primary btn-dim">
                                          <em className="icon ni ni-search me-1" />
                                          <font>검색</font>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="nk-files-group user-days">
                              <div
                                className="table-wrapper"
                                style={{
                                  borderTop: "1px dotted #BBB",
                                  paddingTop: "5px 0",
                                }}
                              >
                                <div className="table-responsive">
                                  <table
                                    cellSpacing="0"
                                    className="table table-small-font table-tighten table-bordered table-striped navbar-fixed-top"
                                  >
                                    <thead>
                                      <tr>
                                        <th>
                                          <span className="sub-text text-center">
                                            일별
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            화폐
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            관리자 지급
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            관리자 회수
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            상부가 지급
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            상부가 회수
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            하부에 지급
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            하부를 회수
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody />
                                    <tfoot className="dt_user_view_total">
                                      <tr>
                                        <td className="text-center">합계</td>
                                        <td className="text-center">KRW</td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane" id="tabintab04">
                        <div className="nk-block">
                          <div className="card">
                            <div className="card-inner-group">
                              <div className="card-inner p-3 p-0">
                                <div className="nk-block nk-block-lg">
                                  <div className="row tbSearch">
                                    <div className="col-12 col-sm-12" />
                                    <div className="col-12 col-md-5 col-xl-5 col-xxl-5 offset-xxl-2">
                                      <div className="form-group">
                                        <div className="form-control-wrap raw">
                                          <div className="input-daterange input-group">
                                            <div className="form-control-wrap">
                                              <div className="form-icon form-icon-left">
                                                <em className="icon ni ni-calendar" />
                                              </div>
                                              <input
                                                className="form-control date-picker"
                                                data-date-format="yyyy-mm-dd"
                                                id="sdate"
                                                type="text"
                                              />
                                            </div>
                                            <div className="input-group-addon">
                                              ~
                                            </div>
                                            <div className="form-control-wrap">
                                              <div className="form-icon form-icon-left">
                                                <em className="icon ni ni-calendar" />
                                              </div>
                                              <input
                                                className="form-control date-picker"
                                                data-date-format="yyyy-mm-dd"
                                                id="edate"
                                                type="text"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-10 col-md-5 col-xl-5 col-xxl-4">
                                      <div className="form-group">
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Yesterday"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Yesterday"
                                          >
                                            어제
                                          </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Today"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Today"
                                          >
                                            오늘
                                          </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Week"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Week"
                                          >
                                            일주일
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-2 col-sm-2 col-xl-2 col-xxl-1">
                                      <div className="input-group withcontrol">
                                        <button className="btn btn-outline-primary btn-dim">
                                          <em className="icon ni ni-search me-1" />
                                          <font>검색</font>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="nk-files-group user-days">
                              <div
                                className="table-wrapper"
                                style={{
                                  borderTop: "1px dotted #BBB",
                                  paddingTop: "5px 0",
                                }}
                              >
                                <div className="table-responsive">
                                  <table
                                    cellSpacing="0"
                                    className="table table-small-font table-tighten table-bordered table-striped navbar-fixed-top"
                                  >
                                    <thead>
                                      <tr>
                                        <th>
                                          <span className="sub-text text-center">
                                            일별
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            화폐
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            관리자 회원 지급
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            관리자 회원 회수
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            상부가 회원 지급
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            상부가 회원 회수
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            회원 수동 지급
                                          </span>
                                        </th>
                                        <th>
                                          <span className="sub-text text-center">
                                            회원 수동 회수
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody />
                                    <tfoot className="dt_user_view_total">
                                      <tr>
                                        <td className="text-center">합계</td>
                                        <td className="text-center">KRW</td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                        <td className="text-end">
                                          <span>0</span>
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane" id="tb_userlist">
                    <div className="nk-block">
                      <div className="card">
                        <div className="card-inner-group">
                          <div className="card-inner">
                            <div className="nk-block nk-block-lg vUserLists">
                              <div className="w-100 card card-bordered">
                                <div className="card-inner-group">
                                  <div className="card-inner">
                                    <div className="row g-2">
                                      <div className="col-12 col-sm-12 col-md-12 col-xl-1 col-xxl-1" />
                                      <div className="col-12 col-sm-12 col-md-12 col-xl-11 col-xxl-11">
                                        <div className="input-group">
                                          <div className="input-group-prepend">
                                            <button
                                              className="btn btn-outline-light btn-dim dropdown-toggle"
                                              data-bs-toggle="dropdown"
                                            >
                                              <span>아이디</span>
                                              <em className="icon mx-n1 ni ni-chevron-down" />
                                            </button>
                                            <div className="dropdown-menu">
                                              <ul className="link-list-opt no-bdr">
                                                <li>
                                                  <a href="#">아이디</a>
                                                </li>
                                                <li>
                                                  <a href="#">사이트 아이디</a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <input
                                            aria-label="Text input with dropdown button"
                                            className="form-control"
                                            id="stext"
                                            placeholder="검색어"
                                            type="text"
                                          />
                                          <div className="input-group-append">
                                            <button className="btn btn-outline-primary btn-dim">
                                              <em className="icon ni ni-search me-2" />
                                              <font>검색</font>
                                            </button>
                                          </div>
                                          <div className="dp_md_st">
                                            <select className="form-select">
                                              <option value="">지갑</option>
                                              <option value="n">트랜스</option>
                                              <option value="y">심리스</option>
                                              <option value="m">믹스형</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner">
                                    <div className="row justify-end">
                                      <div className="col-12 col-md-6">
                                        <ul
                                          className="pagination justify-content-center justify-content-md-start"
                                          style={{
                                            float: "right",
                                          }}
                                        >
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font>처음</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font>이전</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font>다음</font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="monthbet:1">
                                            금월배팅 - 오름차순
                                          </option>
                                          <option value="monthbet:-1">
                                            금월배팅 - 내림차순
                                          </option>
                                          <option value="monthwin:1">
                                            금월당첨금 - 오름차순
                                          </option>
                                          <option value="monthwin:-1">
                                            금월당첨금 - 내림차순
                                          </option>
                                          <option value="monthrev:1">
                                            금월손익금 - 오름차순
                                          </option>
                                          <option value="monthrev:-1">
                                            금월손익금 - 내림차순
                                          </option>
                                          <option value="cash:asc">
                                            보유머니 - 오름차순
                                          </option>
                                          <option value="cash:desc">
                                            보유머니 - 내림차순
                                          </option>
                                          <option value="created_at:asc">
                                            생성일 - 오름차순
                                          </option>
                                          <option value="created_at:desc">
                                            생성일 - 내림차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner p-0">
                                    <div
                                      className="table-wrapper"
                                      style={{
                                        borderTop: "1px dotted #BBB",
                                        paddingTop: "5px 0",
                                      }}
                                    >
                                      <div className="btn-toolbar justify-content-between">
                                        <div className="btn-group focus-btn-group" />
                                        <div className="btn-group dropdown-btn-group dropdown">
                                          <button
                                            className="btn btn-sm btn-outline-primary"
                                            type="button"
                                          >
                                            모두 보기
                                          </button>
                                          <button
                                            className="btn btn-sm btn-outline-primary dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            id="displayMenuid4e243004b76c1"
                                            type="button"
                                          >
                                            항목 선택{" "}
                                            <em className="icon ni ni-chevron-down ms-1 me-n1" />
                                          </button>
                                          <ul className="dropdown-menu">
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-0"
                                                id="toggle-id4e243004b76c1-col-0"
                                                name="toggle-id4e243004b76c1-col-0"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-0">
                                                트리정보
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-1"
                                                id="toggle-id4e243004b76c1-col-1"
                                                name="toggle-id4e243004b76c1-col-1"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-1">
                                                소속 에이전트
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-2"
                                                id="toggle-id4e243004b76c1-col-2"
                                                name="toggle-id4e243004b76c1-col-2"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-2">
                                                지갑{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-3"
                                                id="toggle-id4e243004b76c1-col-3"
                                                name="toggle-id4e243004b76c1-col-3"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-3">
                                                회원정보{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-4"
                                                id="toggle-id4e243004b76c1-col-4"
                                                name="toggle-id4e243004b76c1-col-4"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-4">
                                                화폐
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-5"
                                                id="toggle-id4e243004b76c1-col-5"
                                                name="toggle-id4e243004b76c1-col-5"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-5">
                                                금월베팅금
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-6"
                                                id="toggle-id4e243004b76c1-col-6"
                                                name="toggle-id4e243004b76c1-col-6"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-6">
                                                금월당첨금
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-7"
                                                id="toggle-id4e243004b76c1-col-7"
                                                name="toggle-id4e243004b76c1-col-7"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-7">
                                                금월손익금
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-8"
                                                id="toggle-id4e243004b76c1-col-8"
                                                name="toggle-id4e243004b76c1-col-8"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-8">
                                                보유머니{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id4e243004b76c1-col-9"
                                                id="toggle-id4e243004b76c1-col-9"
                                                name="toggle-id4e243004b76c1-col-9"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id4e243004b76c1-col-9">
                                                활동로그
                                              </label>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div className="table-responsive">
                                        <div
                                          style={{
                                            padding: "5px 0px",
                                          }}
                                        >
                                          <table
                                            cellSpacing="0"
                                            className="table table-small-font table-tighten table-bordered table-striped"
                                            style={{
                                              borderTop:
                                                "1px solid rgb(204, 204, 204)",
                                              padding: "5px 0px",
                                            }}
                                          >
                                            <thead>
                                              <tr data-pos-y="0">
                                                <th
                                                  className="text-center"
                                                  data-pos-x="0"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-0"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  트리정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="1"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  소속 에이전트
                                                </th>
                                                <th
                                                  className="text-center col-wallet"
                                                  data-bs-original-title="T : 트랜스 S : 심리스"
                                                  data-bs-toggle="tooltip"
                                                  data-pos-x="2"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-2"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  지갑{" "}
                                                  <em className="icon ni ni-info-fill vam" />
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="3"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-3"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span
                                                    data-bs-original-title="아이디 / 사이트아이디"
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top"
                                                  >
                                                    회원정보{" "}
                                                    <em className="icon ni ni-info-fill vam" />
                                                  </span>
                                                </th>
                                                <th
                                                  className="text-center col-currency"
                                                  data-pos-x="4"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-4"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  화폐
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="5"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-5"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  금월베팅금
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="6"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-6"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  금월당첨금
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="7"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-7"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  금월손익금
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-bs-original-title="심리스 유저머니는 참고용으로 10분간 배팅활동이 없을시 '0원'으로 변경됩니다"
                                                  data-bs-toggle="tooltip"
                                                  data-placement="top"
                                                  data-pos-x="8"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-8"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  보유머니{" "}
                                                  <em className="icon ni ni-info-fill vam" />
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="9"
                                                  data-priority="1"
                                                  id="id4e243004b76c1-col-9"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  활동로그
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr data-pos-y="0">
                                                <td
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-0"
                                                  data-org-colspan="1"
                                                  data-pos-x="0"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>
                                                    <em
                                                      className="badge me-1 super"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      Matrixgames
                                                    </em>
                                                  </span>
                                                </td>
                                                <td
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-1"
                                                  data-org-colspan="1"
                                                  data-pos-x="1"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <em
                                                    className="badge me-1 super"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    Matrixgames
                                                  </em>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-2"
                                                  data-org-colspan="1"
                                                  data-pos-x="2"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                                    S
                                                  </em>
                                                </td>
                                                <td
                                                  className="text-start"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-3"
                                                  data-org-colspan="1"
                                                  data-pos-x="3"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div className="user-toggle">
                                                    <a
                                                      className="dropdown-toggle"
                                                      data-bs-toggle="dropdown"
                                                      href="#"
                                                    >
                                                      <div className="user-toggle">
                                                        <div className="user-info">
                                                          <div className="user-name dropdown-indicator">
                                                            <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                              아이디
                                                            </span>
                                                            nx__matr_gtest01
                                                          </div>
                                                          <div className="user-status">
                                                            <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                                              사이트아이디
                                                            </span>
                                                            gtest01
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </a>
                                                    <div className="dropdown-menu dropdown-menu-start">
                                                      <ul className="link-check">
                                                        <li>
                                                          <div className="p-1">
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-info me-1">
                                                                지갑
                                                              </span>
                                                              <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                                                S
                                                              </em>
                                                            </div>
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                                아이디
                                                              </span>
                                                              nx__matr_gtest01
                                                            </div>
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                                                사이트아이디
                                                              </span>
                                                              gtest01
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li className="divider" />
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon far fa-copy" />
                                                            <span>
                                                              아이디 복사
                                                            </span>
                                                          </a>
                                                        </li>
                                                      </ul>
                                                      <ul className="link-list-opt">
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-db-fill" />
                                                            <span>
                                                              베팅정보
                                                            </span>
                                                          </a>
                                                        </li>
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-user-list" />
                                                            <span>
                                                              회원정보
                                                            </span>
                                                          </a>
                                                        </li>
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-account-setting-alt" />
                                                            <span>메모</span>
                                                          </a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-4"
                                                  data-org-colspan="1"
                                                  data-pos-x="4"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  KRW
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-5"
                                                  data-org-colspan="1"
                                                  data-pos-x="5"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-6"
                                                  data-org-colspan="1"
                                                  data-pos-x="6"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-7"
                                                  data-org-colspan="1"
                                                  data-pos-x="7"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-8"
                                                  data-org-colspan="1"
                                                  data-pos-x="8"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span className="text-info">
                                                    0
                                                  </span>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-9"
                                                  data-org-colspan="1"
                                                  data-pos-x="9"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-secondary badge-date me-1">
                                                        가입일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "95%",
                                                        }}
                                                      >
                                                        2024-09-27
                                                        <font className="dateInHour">
                                                          {" "}
                                                          (18:02:57 UTC +9)
                                                        </font>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <hr className="m-0" />
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-primary badge-date me-1">
                                                        수정일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "95%",
                                                        }}
                                                      >
                                                        2024-09-27
                                                        <font className="dateInHour">
                                                          {" "}
                                                          (18:02:57 UTC +9)
                                                        </font>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <hr className="m-0" />
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-danger badge-date me-1">
                                                        접속일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr data-pos-y="1">
                                                <td
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-0"
                                                  data-org-colspan="1"
                                                  data-pos-x="0"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>
                                                    <em
                                                      className="badge me-1 super"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      Matrixgames
                                                    </em>
                                                  </span>
                                                </td>
                                                <td
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-1"
                                                  data-org-colspan="1"
                                                  data-pos-x="1"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <em
                                                    className="badge me-1 super"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    Matrixgames
                                                  </em>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-2"
                                                  data-org-colspan="1"
                                                  data-pos-x="2"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                                    S
                                                  </em>
                                                </td>
                                                <td
                                                  className="text-start"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-3"
                                                  data-org-colspan="1"
                                                  data-pos-x="3"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div className="user-toggle">
                                                    <a
                                                      className="dropdown-toggle"
                                                      data-bs-toggle="dropdown"
                                                      href="#"
                                                    >
                                                      <div className="user-toggle">
                                                        <div className="user-info">
                                                          <div className="user-name dropdown-indicator">
                                                            <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                              아이디
                                                            </span>
                                                            nx__matr_gtest01
                                                          </div>
                                                          <div className="user-status">
                                                            <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                                              사이트아이디
                                                            </span>
                                                            gtest01
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </a>
                                                    <div className="dropdown-menu dropdown-menu-start">
                                                      <ul className="link-check">
                                                        <li>
                                                          <div className="p-1">
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-info me-1">
                                                                지갑
                                                              </span>
                                                              <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                                                S
                                                              </em>
                                                            </div>
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                                아이디
                                                              </span>
                                                              nx__matr_gtest01
                                                            </div>
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                                                사이트아이디
                                                              </span>
                                                              gtest01
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li className="divider" />
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon far fa-copy" />
                                                            <span>
                                                              아이디 복사
                                                            </span>
                                                          </a>
                                                        </li>
                                                      </ul>
                                                      <ul className="link-list-opt">
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-db-fill" />
                                                            <span>
                                                              베팅정보
                                                            </span>
                                                          </a>
                                                        </li>
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-user-list" />
                                                            <span>
                                                              회원정보
                                                            </span>
                                                          </a>
                                                        </li>
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-account-setting-alt" />
                                                            <span>메모</span>
                                                          </a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-4"
                                                  data-org-colspan="1"
                                                  data-pos-x="4"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  KRW
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-5"
                                                  data-org-colspan="1"
                                                  data-pos-x="5"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-6"
                                                  data-org-colspan="1"
                                                  data-pos-x="6"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-7"
                                                  data-org-colspan="1"
                                                  data-pos-x="7"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-8"
                                                  data-org-colspan="1"
                                                  data-pos-x="8"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span className="text-info">
                                                    0
                                                  </span>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-9"
                                                  data-org-colspan="1"
                                                  data-pos-x="9"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-secondary badge-date me-1">
                                                        가입일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "95%",
                                                        }}
                                                      >
                                                        2024-09-27
                                                        <font className="dateInHour">
                                                          {" "}
                                                          (18:02:57 UTC +9)
                                                        </font>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <hr className="m-0" />
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-primary badge-date me-1">
                                                        수정일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "95%",
                                                        }}
                                                      >
                                                        2024-09-27
                                                        <font className="dateInHour">
                                                          {" "}
                                                          (18:02:57 UTC +9)
                                                        </font>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <hr className="m-0" />
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-danger badge-date me-1">
                                                        접속일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr data-pos-y="2">
                                                <td
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-0"
                                                  data-org-colspan="1"
                                                  data-pos-x="0"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>
                                                    <em
                                                      className="badge me-1 super"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      Matrixgames
                                                    </em>
                                                  </span>
                                                </td>
                                                <td
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-1"
                                                  data-org-colspan="1"
                                                  data-pos-x="1"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <em
                                                    className="badge me-1 super"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    Matrixgames
                                                  </em>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-2"
                                                  data-org-colspan="1"
                                                  data-pos-x="2"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                                    S
                                                  </em>
                                                </td>
                                                <td
                                                  className="text-start"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-3"
                                                  data-org-colspan="1"
                                                  data-pos-x="3"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div className="user-toggle">
                                                    <a
                                                      className="dropdown-toggle"
                                                      data-bs-toggle="dropdown"
                                                      href="#"
                                                    >
                                                      <div className="user-toggle">
                                                        <div className="user-info">
                                                          <div className="user-name dropdown-indicator">
                                                            <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                              아이디
                                                            </span>
                                                            nx__matr_gtest01
                                                          </div>
                                                          <div className="user-status">
                                                            <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                                              사이트아이디
                                                            </span>
                                                            gtest01
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </a>
                                                    <div className="dropdown-menu dropdown-menu-start">
                                                      <ul className="link-check">
                                                        <li>
                                                          <div className="p-1">
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-info me-1">
                                                                지갑
                                                              </span>
                                                              <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                                                S
                                                              </em>
                                                            </div>
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                                아이디
                                                              </span>
                                                              nx__matr_gtest01
                                                            </div>
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                                                사이트아이디
                                                              </span>
                                                              gtest01
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li className="divider" />
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon far fa-copy" />
                                                            <span>
                                                              아이디 복사
                                                            </span>
                                                          </a>
                                                        </li>
                                                      </ul>
                                                      <ul className="link-list-opt">
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-db-fill" />
                                                            <span>
                                                              베팅정보
                                                            </span>
                                                          </a>
                                                        </li>
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-user-list" />
                                                            <span>
                                                              회원정보
                                                            </span>
                                                          </a>
                                                        </li>
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-account-setting-alt" />
                                                            <span>메모</span>
                                                          </a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-4"
                                                  data-org-colspan="1"
                                                  data-pos-x="4"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  KRW
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-5"
                                                  data-org-colspan="1"
                                                  data-pos-x="5"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-6"
                                                  data-org-colspan="1"
                                                  data-pos-x="6"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-7"
                                                  data-org-colspan="1"
                                                  data-pos-x="7"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-8"
                                                  data-org-colspan="1"
                                                  data-pos-x="8"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span className="text-info">
                                                    0
                                                  </span>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id4e243004b76c1-col-9"
                                                  data-org-colspan="1"
                                                  data-pos-x="9"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-secondary badge-date me-1">
                                                        가입일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "95%",
                                                        }}
                                                      >
                                                        2024-09-27
                                                        <font className="dateInHour">
                                                          {" "}
                                                          (18:02:57 UTC +9)
                                                        </font>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <hr className="m-0" />
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-primary badge-date me-1">
                                                        수정일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "95%",
                                                        }}
                                                      >
                                                        2024-09-27
                                                        <font className="dateInHour">
                                                          {" "}
                                                          (18:02:57 UTC +9)
                                                        </font>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <hr className="m-0" />
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-danger badge-date me-1">
                                                        접속일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner">
                                    <div className="row justify-end">
                                      <div className="col-12 col-md-6">
                                        <ul
                                          className="pagination justify-content-center justify-content-md-start"
                                          style={{
                                            float: "right",
                                          }}
                                        >
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font>처음</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font>이전</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font>다음</font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="monthbet:1">
                                            금월배팅 - 오름차순
                                          </option>
                                          <option value="monthbet:-1">
                                            금월배팅 - 내림차순
                                          </option>
                                          <option value="monthwin:1">
                                            금월당첨금 - 오름차순
                                          </option>
                                          <option value="monthwin:-1">
                                            금월당첨금 - 내림차순
                                          </option>
                                          <option value="monthrev:1">
                                            금월손익금 - 오름차순
                                          </option>
                                          <option value="monthrev:-1">
                                            금월손익금 - 내림차순
                                          </option>
                                          <option value="cash:asc">
                                            보유머니 - 오름차순
                                          </option>
                                          <option value="cash:desc">
                                            보유머니 - 내림차순
                                          </option>
                                          <option value="created_at:asc">
                                            생성일 - 오름차순
                                          </option>
                                          <option value="created_at:desc">
                                            생성일 - 내림차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane" id="tb_usersRealTimelist">
                    <div className="nk-block">
                      <div className="card">
                        <div className="card-inner-group">
                          <div className="card-inner">
                            <div className="nk-block nk-block-lg vUserLists">
                              <div className="w-100 card card-bordered">
                                <div className="card-inner-group">
                                  <div className="card-inner">
                                    <div className="row g-2">
                                      <div className="col-12 col-sm-12 col-md-12 col-xl-1 col-xxl-1" />
                                      <div className="col-12 col-sm-12 col-md-12 col-xl-11 col-xxl-12">
                                        <div className="input-group">
                                          <div className="input-group-prepend">
                                            <button className="btn btn-primary">
                                              total : 0
                                            </button>
                                          </div>
                                          <div className="input-group-prepend">
                                            <button
                                              className="btn btn-outline-light btn-dim dropdown-toggle"
                                              data-bs-toggle="dropdown"
                                            >
                                              <span>아이디</span>
                                              <em className="icon mx-n1 ni ni-chevron-down" />
                                            </button>
                                            <div className="dropdown-menu">
                                              <ul className="link-list-opt no-bdr">
                                                <li>
                                                  <a href="#">아이디</a>
                                                </li>
                                                <li>
                                                  <a href="#">사이트 아이디</a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <input
                                            aria-label="Text input with dropdown button"
                                            className="form-control"
                                            id="stext"
                                            placeholder="검색어"
                                            type="text"
                                          />
                                          <div className="input-group-append">
                                            <button className="btn btn-outline-primary btn-dim">
                                              <em className="icon ni ni-search me-2" />
                                              <font>검색</font>
                                            </button>
                                            <button className="btn btn-outline-info btn-dim">
                                              <i className="fas fa-check" />
                                              <font>일괄 체크</font>
                                            </button>
                                            <button className="btn btn-outline-primary btn-dim">
                                              <i className="fas fa-bolt" />
                                              <font>일괄 Kick</font>
                                            </button>
                                            <button
                                              className="btn btn-outline-warning btn-dim"
                                              data-bs-target="#collapseExample"
                                              data-bs-toggle="collapse"
                                            >
                                              <i className="fas fa-question" />
                                              <font>도움말</font>
                                            </button>
                                          </div>
                                          <div className="dp_md_st">
                                            <select className="form-select">
                                              <option value="">지갑</option>
                                              <option value="n">트랜스</option>
                                              <option value="y">심리스</option>
                                              <option value="m">믹스형</option>
                                            </select>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12 col-md-12 col-xl-11 col-xxl-12">
                                        <div className="row">
                                          <div className="col-md-3 col-lg-3 col-xxl-3">
                                            <div className="form-group mb-sm-0">
                                              <div className="form-control-wrap">
                                                <div className="form-group">
                                                  <div className="form-control-wrap">
                                                    <div
                                                      className="user-toggle intab"
                                                      style={{
                                                        display: "inline-block",
                                                      }}
                                                    >
                                                      <a
                                                        aria-expanded="false"
                                                        className="dropdown-toggle"
                                                        data-bs-auto-close="outside"
                                                        data-bs-toggle="dropdown"
                                                        href="#"
                                                      >
                                                        <div className="user-name dropdown-indicator">
                                                          전체
                                                        </div>
                                                      </a>
                                                      <div className="dropdown-menu">
                                                        <ul className="nav nav-tabs">
                                                          <li className="nav-item">
                                                            <button
                                                              aria-controls="talb11"
                                                              aria-selected="true"
                                                              className="nav-link active"
                                                              data-bs-target="#talb11"
                                                              data-bs-toggle="tab"
                                                              id="home-tab"
                                                              role="tab"
                                                              type="button"
                                                            >
                                                              전체
                                                            </button>
                                                          </li>
                                                          <li className="nav-item">
                                                            <button
                                                              aria-controls="talb11"
                                                              aria-selected="false"
                                                              className="nav-link"
                                                              data-bs-target="#talb22"
                                                              data-bs-toggle="tab"
                                                              id="profile-tab"
                                                              role="tab"
                                                              type="button"
                                                            >
                                                              카지노
                                                            </button>
                                                          </li>
                                                          <li className="nav-item">
                                                            <button
                                                              aria-controls="talb33"
                                                              aria-selected="false"
                                                              className="nav-link"
                                                              data-bs-target="#talb44"
                                                              data-bs-toggle="tab"
                                                              id="contact-tab"
                                                              role="tab"
                                                              type="button"
                                                            >
                                                              슬롯
                                                            </button>
                                                          </li>
                                                          <li className="nav-item">
                                                            <button
                                                              aria-controls="talb55"
                                                              aria-selected="false"
                                                              className="nav-link"
                                                              data-bs-target="#talb55"
                                                              data-bs-toggle="tab"
                                                              id="contact-tab"
                                                              role="tab"
                                                              type="button"
                                                            >
                                                              스포츠
                                                            </button>
                                                          </li>
                                                        </ul>
                                                        <div className="tab-content">
                                                          <div
                                                            className="tab-pane show active"
                                                            id="talb11"
                                                          >
                                                            <div className="input-group">
                                                              <input
                                                                className="form-control"
                                                                type="text"
                                                              />
                                                            </div>
                                                            <ul
                                                              className="link-check"
                                                              style={{
                                                                height: "300px",
                                                                overflow:
                                                                  "auto",
                                                              }}
                                                            >
                                                              <li
                                                                className=""
                                                                value="1"
                                                              >
                                                                <a href="#">
                                                                  에볼루션
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="20"
                                                              >
                                                                <a href="#">
                                                                  드림게이밍
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="141"
                                                              >
                                                                <a href="#">
                                                                  아시안게이밍
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="2"
                                                              >
                                                                <a href="#">
                                                                  프라그마틱
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="675"
                                                              >
                                                                <a href="#">
                                                                  마이크로게이밍
                                                                  그랜드 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="200"
                                                              >
                                                                <a href="#">
                                                                  마이크로게이밍
                                                                  그랜드 카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="75"
                                                              >
                                                                <a href="#">
                                                                  오리엔탈
                                                                  게이밍
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="78"
                                                              >
                                                                <a href="#">
                                                                  빅게이밍
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="94"
                                                              >
                                                                <a href="#">
                                                                  모티베이션
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="32"
                                                              >
                                                                <a href="#">
                                                                  이주기
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="107"
                                                              >
                                                                <a href="#">
                                                                  타이산 카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="114"
                                                              >
                                                                <a href="#">
                                                                  스카이윈드
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="131"
                                                              >
                                                                <a href="#">
                                                                  벳게임즈 TV
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="180"
                                                              >
                                                                <a href="#">
                                                                  섹시 바카라
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="195"
                                                              >
                                                                <a href="#">
                                                                  DB Live 카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="123"
                                                              >
                                                                <a href="#">
                                                                  보타 카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="3"
                                                              >
                                                                <a href="#">
                                                                  프라그마틱
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="142"
                                                              >
                                                                <a href="#">
                                                                  아시안게이밍
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="6"
                                                              >
                                                                <a href="#">
                                                                  하바네로
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="129"
                                                              >
                                                                <a href="#">
                                                                  블루프린트
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="23"
                                                              >
                                                                <a href="#">
                                                                  CQ9 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="27"
                                                              >
                                                                <a href="#">
                                                                  레드타이거
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="130"
                                                              >
                                                                <a href="#">
                                                                  슬롯 매트릭스
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="41"
                                                              >
                                                                <a href="#">
                                                                  GMW
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="44"
                                                              >
                                                                <a href="#">
                                                                  부운고
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="52"
                                                              >
                                                                <a href="#">
                                                                  넷엔트
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="56"
                                                              >
                                                                <a href="#">
                                                                  BTG
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="57"
                                                              >
                                                                <a href="#">
                                                                  PG소프트
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="58"
                                                              >
                                                                <a href="#">
                                                                  아스펙트
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="59"
                                                              >
                                                                <a href="#">
                                                                  벳소프트 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="60"
                                                              >
                                                                <a href="#">
                                                                  스카이윈드
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="77"
                                                              >
                                                                <a href="#">
                                                                  FTG 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="79"
                                                              >
                                                                <a href="#">
                                                                  넷게이밍
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="84"
                                                              >
                                                                <a href="#">
                                                                  플레이스타
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="85"
                                                              >
                                                                <a href="#">
                                                                  NAGA
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="86"
                                                              >
                                                                <a href="#">
                                                                  넥스트스핀
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="87"
                                                              >
                                                                <a href="#">
                                                                  플레이앤고
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="89"
                                                              >
                                                                <a href="#">
                                                                  에보플레이
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="91"
                                                              >
                                                                <a href="#">
                                                                  아바타UX 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="109"
                                                              >
                                                                <a href="#">
                                                                  릴렉스
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="110"
                                                              >
                                                                <a href="#">
                                                                  릴플레이 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="111"
                                                              >
                                                                <a href="#">
                                                                  판타즈마 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="112"
                                                              >
                                                                <a href="#">
                                                                  부메랑 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="113"
                                                              >
                                                                <a href="#">
                                                                  포더플레이어
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="119"
                                                              >
                                                                <a href="#">
                                                                  노리밋시티
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="120"
                                                              >
                                                                <a href="#">
                                                                  핵쏘우게이밍
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="182"
                                                              >
                                                                <a href="#">
                                                                  조커 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="186"
                                                              >
                                                                <a href="#">
                                                                  JILI 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="132"
                                                              >
                                                                <a href="#">
                                                                  펀키게임즈
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="126"
                                                              >
                                                                <a href="#">
                                                                  비게이밍 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="127"
                                                              >
                                                                <a href="#">
                                                                  부밍게임즈
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="128"
                                                              >
                                                                <a href="#">
                                                                  익스팬스 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="201"
                                                              >
                                                                <a href="#">
                                                                  드래곤소프트
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="690"
                                                              >
                                                                <a href="#">
                                                                  와즈단
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="688"
                                                              >
                                                                <a href="#">
                                                                  옥토플레이
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="687"
                                                              >
                                                                <a href="#">
                                                                  이그드라실
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="194"
                                                              >
                                                                <a href="#">
                                                                  BT1
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            className="tab-pane"
                                                            id="talb22"
                                                          >
                                                            <div className="input-group">
                                                              <input
                                                                className="form-control"
                                                                type="text"
                                                              />
                                                            </div>
                                                            <ul
                                                              className="link-check"
                                                              style={{
                                                                height: "300px",
                                                                overflow:
                                                                  "auto",
                                                              }}
                                                            >
                                                              <li
                                                                className=""
                                                                value="1"
                                                              >
                                                                <a href="#">
                                                                  에볼루션
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="20"
                                                              >
                                                                <a href="#">
                                                                  드림게이밍
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="141"
                                                              >
                                                                <a href="#">
                                                                  아시안게이밍
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="2"
                                                              >
                                                                <a href="#">
                                                                  프라그마틱
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="200"
                                                              >
                                                                <a href="#">
                                                                  마이크로게이밍
                                                                  그랜드 카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="75"
                                                              >
                                                                <a href="#">
                                                                  오리엔탈
                                                                  게이밍
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="78"
                                                              >
                                                                <a href="#">
                                                                  빅게이밍
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="94"
                                                              >
                                                                <a href="#">
                                                                  모티베이션
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="32"
                                                              >
                                                                <a href="#">
                                                                  이주기
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="107"
                                                              >
                                                                <a href="#">
                                                                  타이산 카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="114"
                                                              >
                                                                <a href="#">
                                                                  스카이윈드
                                                                  카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="131"
                                                              >
                                                                <a href="#">
                                                                  벳게임즈 TV
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="180"
                                                              >
                                                                <a href="#">
                                                                  섹시 바카라
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="195"
                                                              >
                                                                <a href="#">
                                                                  DB Live 카지노
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="123"
                                                              >
                                                                <a href="#">
                                                                  보타 카지노
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            className="tab-pane"
                                                            id="talb44"
                                                          >
                                                            <div className="input-group">
                                                              <input
                                                                className="form-control"
                                                                type="text"
                                                              />
                                                            </div>
                                                            <ul
                                                              className="link-check"
                                                              style={{
                                                                height: "300px",
                                                                overflow:
                                                                  "auto",
                                                              }}
                                                            >
                                                              <li
                                                                className=""
                                                                value="675"
                                                              >
                                                                <a href="#">
                                                                  마이크로게이밍
                                                                  그랜드 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="3"
                                                              >
                                                                <a href="#">
                                                                  프라그마틱
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="142"
                                                              >
                                                                <a href="#">
                                                                  아시안게이밍
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="6"
                                                              >
                                                                <a href="#">
                                                                  하바네로
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="129"
                                                              >
                                                                <a href="#">
                                                                  블루프린트
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="23"
                                                              >
                                                                <a href="#">
                                                                  CQ9 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="27"
                                                              >
                                                                <a href="#">
                                                                  레드타이거
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="130"
                                                              >
                                                                <a href="#">
                                                                  슬롯 매트릭스
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="41"
                                                              >
                                                                <a href="#">
                                                                  GMW
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="44"
                                                              >
                                                                <a href="#">
                                                                  부운고
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="52"
                                                              >
                                                                <a href="#">
                                                                  넷엔트
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="56"
                                                              >
                                                                <a href="#">
                                                                  BTG
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="57"
                                                              >
                                                                <a href="#">
                                                                  PG소프트
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="58"
                                                              >
                                                                <a href="#">
                                                                  아스펙트
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="59"
                                                              >
                                                                <a href="#">
                                                                  벳소프트 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="60"
                                                              >
                                                                <a href="#">
                                                                  스카이윈드
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="77"
                                                              >
                                                                <a href="#">
                                                                  FTG 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="79"
                                                              >
                                                                <a href="#">
                                                                  넷게이밍
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="84"
                                                              >
                                                                <a href="#">
                                                                  플레이스타
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="85"
                                                              >
                                                                <a href="#">
                                                                  NAGA
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="86"
                                                              >
                                                                <a href="#">
                                                                  넥스트스핀
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="87"
                                                              >
                                                                <a href="#">
                                                                  플레이앤고
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="89"
                                                              >
                                                                <a href="#">
                                                                  에보플레이
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="91"
                                                              >
                                                                <a href="#">
                                                                  아바타UX 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="109"
                                                              >
                                                                <a href="#">
                                                                  릴렉스
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="110"
                                                              >
                                                                <a href="#">
                                                                  릴플레이 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="111"
                                                              >
                                                                <a href="#">
                                                                  판타즈마 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="112"
                                                              >
                                                                <a href="#">
                                                                  부메랑 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="113"
                                                              >
                                                                <a href="#">
                                                                  포더플레이어
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="119"
                                                              >
                                                                <a href="#">
                                                                  노리밋시티
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="120"
                                                              >
                                                                <a href="#">
                                                                  핵쏘우게이밍
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="182"
                                                              >
                                                                <a href="#">
                                                                  조커 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="186"
                                                              >
                                                                <a href="#">
                                                                  JILI 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="132"
                                                              >
                                                                <a href="#">
                                                                  펀키게임즈
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="126"
                                                              >
                                                                <a href="#">
                                                                  비게이밍 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="127"
                                                              >
                                                                <a href="#">
                                                                  부밍게임즈
                                                                  슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="128"
                                                              >
                                                                <a href="#">
                                                                  익스팬스 슬롯
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="201"
                                                              >
                                                                <a href="#">
                                                                  드래곤소프트
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="690"
                                                              >
                                                                <a href="#">
                                                                  와즈단
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="688"
                                                              >
                                                                <a href="#">
                                                                  옥토플레이
                                                                </a>
                                                              </li>
                                                              <li
                                                                className=""
                                                                value="687"
                                                              >
                                                                <a href="#">
                                                                  이그드라실
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            className="tab-pane"
                                                            id="talb55"
                                                          >
                                                            <div className="input-group">
                                                              <input
                                                                className="form-control"
                                                                type="text"
                                                              />
                                                            </div>
                                                            <ul
                                                              className="link-check"
                                                              style={{
                                                                height: "300px",
                                                                overflow:
                                                                  "auto",
                                                              }}
                                                            >
                                                              <li
                                                                className=""
                                                                value="194"
                                                              >
                                                                <a href="#">
                                                                  BT1
                                                                </a>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                          <div
                                                            className="tab-pane"
                                                            id="talb66"
                                                          >
                                                            <div className="input-group">
                                                              <input
                                                                className="form-control"
                                                                type="text"
                                                              />
                                                            </div>
                                                            <ul
                                                              className="link-check"
                                                              style={{
                                                                height: "300px",
                                                                overflow:
                                                                  "auto",
                                                              }}
                                                            />
                                                          </div>
                                                          <div
                                                            className="tab-pane"
                                                            id="talb77"
                                                          >
                                                            <div className="input-group">
                                                              <input
                                                                className="form-control"
                                                                type="text"
                                                              />
                                                            </div>
                                                            <ul
                                                              className="link-check"
                                                              style={{
                                                                height: "300px",
                                                                overflow:
                                                                  "auto",
                                                              }}
                                                            />
                                                          </div>
                                                        </div>
                                                        <div className="tab-con-btnset">
                                                          <div className="btn btn-sm btn-block btn-reset">
                                                            <i className="fas fa-redo" />
                                                            초기화
                                                          </div>
                                                          <div className="btn btn-sm btn-block btn-closeTab">
                                                            <i className="far fa-times-circle" />
                                                            닫기
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <label
                                                      className="form-label-outlined"
                                                      htmlFor="outlined-select"
                                                    >
                                                      게임사 선택
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="collapse pt-3"
                                      id="collapseExample"
                                    >
                                      <div className="alert alert-secondary">
                                        <div className="text-danger">
                                          ● 리스트 갱신주기는 1분입니다.
                                        </div>
                                        <div className="text-danger">
                                          {`● 보유금은 베팅==>결과 처리시 갱신됩니다.`}
                                        </div>
                                        <div className="text-danger">
                                          ● 유저 Kick 처리시에는 인게임내에서
                                          배팅이 불가합니다.
                                        </div>
                                        <div className="text-danger">
                                          {" "}
                                          ● 주의 : Kick 기능을 수시로 사용시
                                          일부게임사에서는 게임차단 및
                                          계정제재가 생길수 있으니 업체 점검등
                                          필요시에만 사용권장합니다.{" "}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner">
                                    <div className="row justify-end">
                                      <div className="col-12 col-md-6">
                                        <ul
                                          className="pagination justify-content-center justify-content-md-start"
                                          style={{
                                            float: "right",
                                          }}
                                        >
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font>처음</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font>이전</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font>다음</font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="cash:asc">
                                            보유머니 - 오름차순
                                          </option>
                                          <option value="cash:desc">
                                            보유머니 - 내림차순
                                          </option>
                                          <option value="created_at:asc">
                                            접속시간 - 오름차순
                                          </option>
                                          <option value="created_at:desc">
                                            접속시간 - 내림차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner p-0">
                                    <div
                                      className="table-wrapper"
                                      style={{
                                        borderTop: "1px dotted #BBB",
                                        paddingTop: "5px 0",
                                      }}
                                    >
                                      <div className="btn-toolbar justify-content-between">
                                        <div className="btn-group focus-btn-group" />
                                        <div className="btn-group dropdown-btn-group dropdown">
                                          <button
                                            className="btn btn-sm btn-outline-primary"
                                            type="button"
                                          >
                                            모두 보기
                                          </button>
                                          <button
                                            className="btn btn-sm btn-outline-primary dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            id="displayMenuida794a61ead2e18"
                                            type="button"
                                          >
                                            항목 선택{" "}
                                            <em className="icon ni ni-chevron-down ms-1 me-n1" />
                                          </button>
                                          <ul className="dropdown-menu">
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-0"
                                                id="toggle-ida794a61ead2e18-col-0"
                                                name="toggle-ida794a61ead2e18-col-0"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-0">
                                                Check
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-1"
                                                id="toggle-ida794a61ead2e18-col-1"
                                                name="toggle-ida794a61ead2e18-col-1"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-1">
                                                트리정보
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-2"
                                                id="toggle-ida794a61ead2e18-col-2"
                                                name="toggle-ida794a61ead2e18-col-2"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-2">
                                                소속 에이전트
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-3"
                                                id="toggle-ida794a61ead2e18-col-3"
                                                name="toggle-ida794a61ead2e18-col-3"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-3">
                                                지갑{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-4"
                                                id="toggle-ida794a61ead2e18-col-4"
                                                name="toggle-ida794a61ead2e18-col-4"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-4">
                                                회원정보{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-5"
                                                id="toggle-ida794a61ead2e18-col-5"
                                                name="toggle-ida794a61ead2e18-col-5"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-5">
                                                게임정보
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-6"
                                                id="toggle-ida794a61ead2e18-col-6"
                                                name="toggle-ida794a61ead2e18-col-6"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-6">
                                                화폐
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-7"
                                                id="toggle-ida794a61ead2e18-col-7"
                                                name="toggle-ida794a61ead2e18-col-7"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-7">
                                                보유금
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-8"
                                                id="toggle-ida794a61ead2e18-col-8"
                                                name="toggle-ida794a61ead2e18-col-8"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-8">
                                                Play Time
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-9"
                                                id="toggle-ida794a61ead2e18-col-9"
                                                name="toggle-ida794a61ead2e18-col-9"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-9">
                                                최근접속
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="ida794a61ead2e18-col-10"
                                                id="toggle-ida794a61ead2e18-col-10"
                                                name="toggle-ida794a61ead2e18-col-10"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-ida794a61ead2e18-col-10">
                                                kick
                                              </label>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div
                                        className="table-responsive"
                                        data-pattern="priority-columns"
                                      >
                                        <div
                                          data-pattern="priority-columns"
                                          style={{
                                            padding: "5px 0px",
                                          }}
                                        >
                                          <table
                                            cellSpacing="0"
                                            className="table table-small-font table-tighten table-bordered table-striped"
                                            style={{
                                              borderTop:
                                                "1px solid rgb(204, 204, 204)",
                                              padding: "5px 0px",
                                            }}
                                          >
                                            <thead>
                                              <tr data-pos-y="0">
                                                <th
                                                  className="text-center"
                                                  data-pos-x="0"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-0"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  Check
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="1"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  트리정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="2"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-2"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  소속에이전트
                                                </th>
                                                <th
                                                  className="text-center col-wallet"
                                                  data-bs-original-title="T : 트랜스, S : 심리스, M : 믹스형"
                                                  data-bs-toggle="tooltip"
                                                  data-pos-x="3"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-3"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  지갑{" "}
                                                  <em className="icon ni ni-info-fill vam" />
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="4"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-4"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span
                                                    data-bs-original-title="아이디 / 사이트아이디"
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top"
                                                  >
                                                    회원정보{" "}
                                                    <em className="icon ni ni-info-fill vam" />
                                                  </span>
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="5"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-5"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  게임정보
                                                </th>
                                                <th
                                                  className="text-center col-currency"
                                                  data-pos-x="6"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-6"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  화폐
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="7"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-7"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  보유금
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="8"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-8"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  Play Time
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="9"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-9"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  최근접속
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="10"
                                                  data-priority="1"
                                                  id="id1112c837c54e48-col-10"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  kick
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr data-pos-y="0">
                                                <td
                                                  className="text-center span-cell-emt spn-cell"
                                                  colSpan="14"
                                                  data-pos-x="0"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div className="nk-order-ovwg-ck text-red">
                                                    <h5>
                                                      조회된 정보가 없습니다.
                                                    </h5>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner">
                                    <div className="row justify-end">
                                      <div className="col-12 col-md-6">
                                        <ul
                                          className="pagination justify-content-center justify-content-md-start"
                                          style={{
                                            float: "right",
                                          }}
                                        >
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font>처음</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font>이전</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font>다음</font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="cash:asc">
                                            보유머니 - 오름차순
                                          </option>
                                          <option value="cash:desc">
                                            보유머니 - 내림차순
                                          </option>
                                          <option value="created_at:asc">
                                            접속시간 - 오름차순
                                          </option>
                                          <option value="created_at:desc">
                                            접속시간 - 내림차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane" id="tb_agent">
                    <div className="nk-block">
                      <div className="card">
                        <div className="card-inner-group">
                          <div className="card-inner">
                            <div className="nk-block d-flex vPartnerLists">
                              <div
                                className="d-none d-xl-block w-30 me-1 mt-1 w-min-100px"
                                id="treeZoon"
                              >
                                <div className="form-group">
                                  <div className="btn btn-primary form-icon form-icon-right">
                                    <em className="icon ni ni-search" />
                                  </div>
                                  <input
                                    className="form-control"
                                    list="treeRows"
                                    placeholder="에이전트 검색"
                                    type="text"
                                  />
                                  <datalist
                                    className="link-list-opt no-bdr"
                                    id="treeRows"
                                  >
                                    <option>
                                      <a href="#">Matrixgames</a>
                                    </option>
                                    <option>
                                      <a href="#">Mtxmaster</a>
                                    </option>
                                    <option>
                                      <a href="#">Mtxlvcasino</a>
                                    </option>
                                    <option>
                                      <a href="#">Mtxilanjeju</a>
                                    </option>
                                    <option>
                                      <a href="#">Mtxmrmango</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxtest001</a>
                                    </option>
                                    <option>
                                      <a href="#">grandcasino</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxrainbow</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxlavcsn</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxlavog</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxongame</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxjjroyal</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxvstar</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxjjrolex</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxrainbow01</a>
                                    </option>
                                    <option>
                                      <a href="#">mtxclick01</a>
                                    </option>
                                  </datalist>
                                </div>
                                <div className="dropdown partnerTree">
                                  <a
                                    className="dropdown-toggle btn btn-outline-light d-none"
                                    data-bs-toggle="dropdown"
                                    href="#"
                                  >
                                    <span className="d-none d-sm-inline btn btn-dim btn-outline-primary disabled">
                                      에이전트 선택{" "}
                                      <em className="dd-indc icon ni ni-chevron-down" />
                                    </span>
                                    <span className="badge comDepth03">.</span>
                                    <span>Matrixgames</span>
                                    <div className="memNum">
                                      <span
                                        className="badge"
                                        data-bs-original-title="에이전트수"
                                        data-bs-toggle="tooltip"
                                      >
                                        7
                                      </span>
                                      <span
                                        className="badge"
                                        data-bs-original-title="회원수"
                                        data-bs-placement="top"
                                        data-bs-toggle="tooltip"
                                      >
                                        35
                                      </span>
                                    </div>
                                  </a>
                                  <div className="dropdown-menu p-3 ps-1 d-block">
                                    <div
                                      aria-activedescendant="j1_13"
                                      aria-busy="false"
                                      aria-multiselectable="true"
                                      className="jstree jstree-1 jstree-default"
                                      id="custom-icon-tree"
                                      role="tree"
                                      tabIndex="0"
                                    >
                                      <ul
                                        className="jstree-container-ul jstree-children"
                                        role="group"
                                      >
                                        <li
                                          className="jstree-node jstree-close"
                                          id="0"
                                          role="none"
                                        >
                                          <a href="#">
                                            <i
                                              className="jstree-icon jstree-ocl"
                                              role="presentation"
                                            />
                                          </a>
                                          <div
                                            aria-expanded="true"
                                            aria-level="0"
                                            aria-selected="false"
                                            className="jstree-anchor"
                                            href="#"
                                            role="treeitem"
                                            tabIndex="-1"
                                          >
                                            <i
                                              className="jstree-icon jstree-themeicon"
                                              role="presentation"
                                            />
                                            <a href="#">
                                              <span className="badge super">
                                                super
                                              </span>
                                              <font className="ms-1">
                                                Matrixgames (KRW)
                                              </font>
                                            </a>
                                            <div className="memNum">
                                              <span
                                                className="badge"
                                                data-bs-original-title="에이전트수"
                                                data-bs-toggle="tooltip"
                                              >
                                                7
                                              </span>
                                              <span
                                                className="badge"
                                                data-bs-original-title="회원수"
                                                data-bs-placement="top"
                                                data-bs-toggle="tooltip"
                                              >
                                                35
                                              </span>
                                            </div>
                                          </div>
                                          <ul
                                            className="jstree-container-ul jstree-children"
                                            role="group"
                                          >
                                            <li
                                              className="jstree-node jstree-open"
                                              id="1"
                                              role="none"
                                            >
                                              <i
                                                style={{
                                                  marginLeft: "20px",
                                                }}
                                              />
                                              <div
                                                aria-expanded="true"
                                                aria-level="1"
                                                aria-selected="false"
                                                className="jstree-anchor"
                                                href="#"
                                                role="treeitem"
                                                tabIndex="-1"
                                              >
                                                <i
                                                  className="jstree-icon jstree-themeicon"
                                                  role="presentation"
                                                />
                                                <a href="#">
                                                  <span className="badge M1">
                                                    M1
                                                  </span>
                                                  <font className="ms-1">
                                                    Mtxmaster (KRW)
                                                  </font>
                                                </a>
                                                <div className="memNum">
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="에이전트수"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    0
                                                  </span>
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="회원수"
                                                    data-bs-placement="top"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    0
                                                  </span>
                                                </div>
                                              </div>
                                            </li>
                                            <li
                                              className="jstree-node jstree-close"
                                              id="1"
                                              role="none"
                                            >
                                              <a href="#">
                                                <i
                                                  className="jstree-icon jstree-ocl"
                                                  role="presentation"
                                                />
                                              </a>
                                              <div
                                                aria-expanded="true"
                                                aria-level="1"
                                                aria-selected="false"
                                                className="jstree-anchor"
                                                href="#"
                                                role="treeitem"
                                                tabIndex="-1"
                                              >
                                                <i
                                                  className="jstree-icon jstree-themeicon"
                                                  role="presentation"
                                                />
                                                <a href="#">
                                                  <span className="badge M1">
                                                    M1
                                                  </span>
                                                  <font className="ms-1">
                                                    Mtxlvcasino (KRW){" "}
                                                  </font>
                                                </a>
                                                <div className="memNum">
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="에이전트수"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    3
                                                  </span>
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="회원수"
                                                    data-bs-placement="top"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    0
                                                  </span>
                                                </div>
                                              </div>
                                            </li>
                                            <li
                                              className="jstree-node jstree-close"
                                              id="1"
                                              role="none"
                                            >
                                              <a href="#">
                                                <i
                                                  className="jstree-icon jstree-ocl"
                                                  role="presentation"
                                                />
                                              </a>
                                              <div
                                                aria-expanded="true"
                                                aria-level="1"
                                                aria-selected="false"
                                                className="jstree-anchor"
                                                href="#"
                                                role="treeitem"
                                                tabIndex="-1"
                                              >
                                                <i
                                                  className="jstree-icon jstree-themeicon"
                                                  role="presentation"
                                                />
                                                <a href="#">
                                                  <span className="badge M1">
                                                    M1
                                                  </span>
                                                  <font className="ms-1">
                                                    Mtxilanjeju (KRW){" "}
                                                  </font>
                                                </a>
                                                <div className="memNum">
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="에이전트수"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    3
                                                  </span>
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="회원수"
                                                    data-bs-placement="top"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    0
                                                  </span>
                                                </div>
                                              </div>
                                            </li>
                                            <li
                                              className="jstree-node jstree-close"
                                              id="1"
                                              role="none"
                                            >
                                              <a href="#">
                                                <i
                                                  className="jstree-icon jstree-ocl"
                                                  role="presentation"
                                                />
                                              </a>
                                              <div
                                                aria-expanded="true"
                                                aria-level="1"
                                                aria-selected="false"
                                                className="jstree-anchor"
                                                href="#"
                                                role="treeitem"
                                                tabIndex="-1"
                                              >
                                                <i
                                                  className="jstree-icon jstree-themeicon"
                                                  role="presentation"
                                                />
                                                <a href="#">
                                                  <span className="badge M1">
                                                    M1
                                                  </span>
                                                  <font className="ms-1">
                                                    Mtxmrmango (KRW){" "}
                                                  </font>
                                                </a>
                                                <div className="memNum">
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="에이전트수"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    2
                                                  </span>
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="회원수"
                                                    data-bs-placement="top"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    0
                                                  </span>
                                                </div>
                                              </div>
                                            </li>
                                            <li
                                              className="jstree-node jstree-open"
                                              id="1"
                                              role="none"
                                            >
                                              <i
                                                style={{
                                                  marginLeft: "20px",
                                                }}
                                              />
                                              <div
                                                aria-expanded="true"
                                                aria-level="1"
                                                aria-selected="false"
                                                className="jstree-anchor"
                                                href="#"
                                                role="treeitem"
                                                tabIndex="-1"
                                              >
                                                <i
                                                  className="jstree-icon jstree-themeicon"
                                                  role="presentation"
                                                />
                                                <a href="#">
                                                  <span className="badge M1">
                                                    M1
                                                  </span>
                                                  <font className="ms-1">
                                                    mtxtest001 (KRW)
                                                  </font>
                                                </a>
                                                <div className="memNum">
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="에이전트수"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    0
                                                  </span>
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="회원수"
                                                    data-bs-placement="top"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    19
                                                  </span>
                                                </div>
                                              </div>
                                            </li>
                                            <li
                                              className="jstree-node jstree-open"
                                              id="1"
                                              role="none"
                                            >
                                              <i
                                                style={{
                                                  marginLeft: "20px",
                                                }}
                                              />
                                              <div
                                                aria-expanded="true"
                                                aria-level="1"
                                                aria-selected="false"
                                                className="jstree-anchor"
                                                href="#"
                                                role="treeitem"
                                                tabIndex="-1"
                                              >
                                                <i
                                                  className="jstree-icon jstree-themeicon"
                                                  role="presentation"
                                                />
                                                <a href="#">
                                                  <span className="badge M1">
                                                    M1
                                                  </span>
                                                  <font className="ms-1">
                                                    grandcasino (KRW)
                                                  </font>
                                                </a>
                                                <div className="memNum">
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="에이전트수"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    0
                                                  </span>
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="회원수"
                                                    data-bs-placement="top"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    14
                                                  </span>
                                                </div>
                                              </div>
                                            </li>
                                            <li
                                              className="jstree-node jstree-open"
                                              id="1"
                                              role="none"
                                            >
                                              <i
                                                style={{
                                                  marginLeft: "20px",
                                                }}
                                              />
                                              <div
                                                aria-expanded="true"
                                                aria-level="1"
                                                aria-selected="false"
                                                className="jstree-anchor"
                                                href="#"
                                                role="treeitem"
                                                tabIndex="-1"
                                              >
                                                <i
                                                  className="jstree-icon jstree-themeicon"
                                                  role="presentation"
                                                />
                                                <a href="#">
                                                  <span className="badge M1">
                                                    M1
                                                  </span>
                                                  <font className="ms-1">
                                                    mtxrainbow (KRW)
                                                  </font>
                                                </a>
                                                <div className="memNum">
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="에이전트수"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    0
                                                  </span>
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="회원수"
                                                    data-bs-placement="top"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    0
                                                  </span>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="custom-control custom-control-sm custom-switch d-none d-none">
                                    <input
                                      className="custom-control-input"
                                      id="sw-treeAllSelect1745236743582"
                                      type="checkbox"
                                    />
                                    <label
                                      className="custom-control-label text-nowrap"
                                      htmlFor="sw-treeAllSelect1745236743582"
                                    >
                                      <strong>하부포함</strong>
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="w-100 card card-bordered">
                                <div className="card-inner-group">
                                  <div className="card-inner p-3">
                                    <div className="nk-block nk-block-lg">
                                      <div className="row tbSearch">
                                        <div className="pb-1 w-10 me-1 mt-1 d-xs-block d-sm-block d-md-block d-lg-none d-xxl-none">
                                          <button className="btn btn-sm btn-outline-primary text-center">
                                            <span>
                                              <i className="fas fa-arrow-down" />{" "}
                                              전체 열기
                                            </span>
                                          </button>
                                        </div>
                                        <div className="col-12 col-sm-12 col-xl-4 col-xxl-4">
                                          <div className="form-group d-block d-xl-none">
                                            <div className="dropdown partnerTree">
                                              <a
                                                className="dropdown-toggle btn btn-outline-light"
                                                data-bs-auto-close="outside"
                                                data-bs-toggle="dropdown"
                                                href="#"
                                                id="dropdownMenuClickable"
                                              >
                                                <span className="d-none d-sm-inline btn btn-dim btn-outline-primary disabled">
                                                  에이전트 선택{" "}
                                                  <em className="dd-indc icon ni ni-chevron-down" />
                                                </span>
                                                <span className="badge super">
                                                  super
                                                </span>
                                                <span>Matrixgames (KRW)</span>
                                                <div className="memNum">
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="에이전트수"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    7
                                                  </span>
                                                  <span
                                                    className="badge"
                                                    data-bs-original-title="회원수"
                                                    data-bs-placement="top"
                                                    data-bs-toggle="tooltip"
                                                  >
                                                    35
                                                  </span>
                                                </div>
                                              </a>
                                              <div
                                                aria-labelledby="dropdownMenuClickable"
                                                className="dropdown-menu dropdown-menu-xl p-3 ps-1"
                                              >
                                                <div className="form-group">
                                                  <div className="btn btn-primary form-icon form-icon-right">
                                                    <em className="icon ni ni-search" />
                                                  </div>
                                                  <input
                                                    className="form-control"
                                                    id="agnetSearch"
                                                    list="treeRows"
                                                    placeholder="에이전트 검색"
                                                    type="text"
                                                  />
                                                </div>
                                                <div
                                                  aria-activedescendant="j1_13"
                                                  aria-busy="false"
                                                  aria-multiselectable="true"
                                                  className="jstree jstree-1 jstree-default"
                                                  id="custom-icon-tree"
                                                  role="tree"
                                                  tabIndex="0"
                                                >
                                                  <ul
                                                    className="jstree-container-ul jstree-children"
                                                    role="group"
                                                  >
                                                    <li
                                                      className="jstree-node jstree-close"
                                                      id="0"
                                                      role="none"
                                                    >
                                                      <a href="#">
                                                        <i
                                                          className="jstree-icon jstree-ocl"
                                                          role="presentation"
                                                        />
                                                      </a>
                                                      <div
                                                        aria-expanded="true"
                                                        aria-level="0"
                                                        aria-selected="false"
                                                        className="jstree-anchor"
                                                        href="#"
                                                        role="treeitem"
                                                        tabIndex="-1"
                                                      >
                                                        <i
                                                          className="jstree-icon jstree-themeicon"
                                                          role="presentation"
                                                        />
                                                        <a href="#">
                                                          <span className="badge super">
                                                            super
                                                          </span>
                                                          <font className="ms-1">
                                                            Matrixgames (KRW)
                                                          </font>
                                                        </a>
                                                        <div className="memNum">
                                                          <span
                                                            className="badge"
                                                            data-bs-original-title="에이전트수"
                                                            data-bs-toggle="tooltip"
                                                          >
                                                            7
                                                          </span>
                                                          <span
                                                            className="badge"
                                                            data-bs-original-title="회원수"
                                                            data-bs-placement="top"
                                                            data-bs-toggle="tooltip"
                                                          >
                                                            35
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <ul
                                                        className="jstree-container-ul jstree-children"
                                                        role="group"
                                                      >
                                                        <li
                                                          className="jstree-node jstree-open"
                                                          id="1"
                                                          role="none"
                                                        >
                                                          <i
                                                            style={{
                                                              marginLeft:
                                                                "20px",
                                                            }}
                                                          />
                                                          <div
                                                            aria-expanded="true"
                                                            aria-level="1"
                                                            aria-selected="false"
                                                            className="jstree-anchor"
                                                            href="#"
                                                            role="treeitem"
                                                            tabIndex="-1"
                                                          >
                                                            <i
                                                              className="jstree-icon jstree-themeicon"
                                                              role="presentation"
                                                            />
                                                            <a href="#">
                                                              <span className="badge M1">
                                                                M1
                                                              </span>
                                                              <font className="ms-1">
                                                                Mtxmaster (KRW)
                                                              </font>
                                                            </a>
                                                            <div className="memNum">
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="에이전트수"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                0
                                                              </span>
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="회원수"
                                                                data-bs-placement="top"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                0
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li
                                                          className="jstree-node jstree-close"
                                                          id="1"
                                                          role="none"
                                                        >
                                                          <a href="#">
                                                            <i
                                                              className="jstree-icon jstree-ocl"
                                                              role="presentation"
                                                            />
                                                          </a>
                                                          <div
                                                            aria-expanded="true"
                                                            aria-level="1"
                                                            aria-selected="false"
                                                            className="jstree-anchor"
                                                            href="#"
                                                            role="treeitem"
                                                            tabIndex="-1"
                                                          >
                                                            <i
                                                              className="jstree-icon jstree-themeicon"
                                                              role="presentation"
                                                            />
                                                            <a href="#">
                                                              <span className="badge M1">
                                                                M1
                                                              </span>
                                                              <font className="ms-1">
                                                                Mtxlvcasino
                                                                (KRW)
                                                              </font>
                                                            </a>
                                                            <div className="memNum">
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="에이전트수"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                3
                                                              </span>
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="회원수"
                                                                data-bs-placement="top"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                0
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li
                                                          className="jstree-node jstree-close"
                                                          id="1"
                                                          role="none"
                                                        >
                                                          <a href="#">
                                                            <i
                                                              className="jstree-icon jstree-ocl"
                                                              role="presentation"
                                                            />
                                                          </a>
                                                          <div
                                                            aria-expanded="true"
                                                            aria-level="1"
                                                            aria-selected="false"
                                                            className="jstree-anchor"
                                                            href="#"
                                                            role="treeitem"
                                                            tabIndex="-1"
                                                          >
                                                            <i
                                                              className="jstree-icon jstree-themeicon"
                                                              role="presentation"
                                                            />
                                                            <a href="#">
                                                              <span className="badge M1">
                                                                M1
                                                              </span>
                                                              <font className="ms-1">
                                                                Mtxilanjeju
                                                                (KRW)
                                                              </font>
                                                            </a>
                                                            <div className="memNum">
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="에이전트수"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                3
                                                              </span>
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="회원수"
                                                                data-bs-placement="top"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                0
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li
                                                          className="jstree-node jstree-close"
                                                          id="1"
                                                          role="none"
                                                        >
                                                          <a href="#">
                                                            <i
                                                              className="jstree-icon jstree-ocl"
                                                              role="presentation"
                                                            />
                                                          </a>
                                                          <div
                                                            aria-expanded="true"
                                                            aria-level="1"
                                                            aria-selected="false"
                                                            className="jstree-anchor"
                                                            href="#"
                                                            role="treeitem"
                                                            tabIndex="-1"
                                                          >
                                                            <i
                                                              className="jstree-icon jstree-themeicon"
                                                              role="presentation"
                                                            />
                                                            <a href="#">
                                                              <span className="badge M1">
                                                                M1
                                                              </span>
                                                              <font className="ms-1">
                                                                Mtxmrmango (KRW)
                                                              </font>
                                                            </a>
                                                            <div className="memNum">
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="에이전트수"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                2
                                                              </span>
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="회원수"
                                                                data-bs-placement="top"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                0
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li
                                                          className="jstree-node jstree-close"
                                                          id="1"
                                                          role="none"
                                                        >
                                                          <a href="#">
                                                            <i
                                                              className="jstree-icon jstree-ocl"
                                                              role="presentation"
                                                            />
                                                          </a>
                                                          <div
                                                            aria-expanded="true"
                                                            aria-level="1"
                                                            aria-selected="false"
                                                            className="jstree-anchor"
                                                            href="#"
                                                            role="treeitem"
                                                            tabIndex="-1"
                                                          >
                                                            <i
                                                              className="jstree-icon jstree-themeicon"
                                                              role="presentation"
                                                            />
                                                            <a href="#">
                                                              <span className="badge M1">
                                                                M1
                                                              </span>
                                                              <font className="ms-1">
                                                                mtxtest001 (KRW)
                                                              </font>
                                                            </a>
                                                            <div className="memNum">
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="에이전트수"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                0
                                                              </span>
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="회원수"
                                                                data-bs-placement="top"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                19
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li
                                                          className="jstree-node jstree-open"
                                                          id="1"
                                                          role="none"
                                                        >
                                                          <i
                                                            style={{
                                                              marginLeft:
                                                                "20px",
                                                            }}
                                                          />
                                                          <div
                                                            aria-expanded="true"
                                                            aria-level="1"
                                                            aria-selected="false"
                                                            className="jstree-anchor"
                                                            href="#"
                                                            role="treeitem"
                                                            tabIndex="-1"
                                                          >
                                                            <i
                                                              className="jstree-icon jstree-themeicon"
                                                              role="presentation"
                                                            />
                                                            <a href="#">
                                                              <span className="badge M1">
                                                                M1
                                                              </span>
                                                              <font className="ms-1">
                                                                grandcasino
                                                                (KRW)
                                                              </font>
                                                            </a>
                                                            <div className="memNum">
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="에이전트수"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                0
                                                              </span>
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="회원수"
                                                                data-bs-placement="top"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                14
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li
                                                          className="jstree-node jstree-open"
                                                          id="1"
                                                          role="none"
                                                        >
                                                          <i
                                                            style={{
                                                              marginLeft:
                                                                "20px",
                                                            }}
                                                          />
                                                          <div
                                                            aria-expanded="true"
                                                            aria-level="1"
                                                            aria-selected="false"
                                                            className="jstree-anchor"
                                                            href="#"
                                                            role="treeitem"
                                                            tabIndex="-1"
                                                          >
                                                            <i
                                                              className="jstree-icon jstree-themeicon"
                                                              role="presentation"
                                                            />
                                                            <a href="#">
                                                              <span className="badge M1">
                                                                M1
                                                              </span>
                                                              <font className="ms-1">
                                                                mtxrainbow (KRW)
                                                              </font>
                                                            </a>
                                                            <div className="memNum">
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="에이전트수"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                0
                                                              </span>
                                                              <span
                                                                className="badge"
                                                                data-bs-original-title="회원수"
                                                                data-bs-placement="top"
                                                                data-bs-toggle="tooltip"
                                                              >
                                                                0
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </li>
                                                      </ul>
                                                    </li>
                                                  </ul>
                                                </div>
                                                <hr />
                                                <div className="row">
                                                  <div className="col-6">
                                                    <div className="btn btn-danger btn-block btn-sm p-0 m-0">
                                                      <i className="fas fa-redo" />
                                                        초기화
                                                    </div>
                                                  </div>
                                                  <div className="col-6">
                                                    <div className="btn btn-gray btn-block btn-sm p-0 m-0">
                                                      <i className="far fa-times-circle" />
                                                        닫기
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="custom-control custom-control-sm custom-switch d-none">
                                                <input
                                                  className="custom-control-input"
                                                  id="sw-treeAllSelect1745236743584"
                                                  type="checkbox"
                                                />
                                                <label
                                                  className="custom-control-label text-nowrap"
                                                  htmlFor="sw-treeAllSelect1745236743584"
                                                >
                                                  <strong>하부포함</strong>
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="form-group d-grid d-xl-block">
                                            <button
                                              className="btn btn-sm btn-primary text-center"
                                              data-bs-target="#ModalInputMadeUser"
                                              data-bs-toggle="modal"
                                            >
                                              <span>
                                                <i className="fas fa-plus-circle" />
                                                하부생성
                                              </span>
                                            </button>
                                          </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-xl-8 col-xxl-8">
                                          <div className="form-control-wrap">
                                            <div className="input-group">
                                              <div className="input-group-prepend d-none d-sm-block">
                                                <div className="btn btn-outline-primary btn-dim">
                                                  <i className="fas fa-search" />
                                                  <font>에이전트 아이디</font>
                                                </div>
                                              </div>
                                              <input
                                                aria-label="Text input with dropdown button"
                                                className="form-control"
                                                id="stext"
                                                placeholder="에이전트 아이디"
                                                type="text"
                                              />
                                              <select className="form-select">
                                                <option value="">지갑</option>
                                                <option value="n">
                                                  트랜스
                                                </option>
                                                <option value="y">
                                                  심리스
                                                </option>
                                                <option value="m">
                                                  믹스형
                                                </option>
                                              </select>
                                              <div className="input-group-append">
                                                <button className="btn btn-outline-primary btn-dim">
                                                  <em className="icon ni ni-search me-2" />{" "}
                                                  검색
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner">
                                    <div className="row justify-end">
                                      <div className="col-12 col-md-6">
                                        <ul
                                          className="pagination justify-content-center justify-content-md-start"
                                          style={{
                                            float: "right",
                                          }}
                                        >
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font>처음</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font>이전</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font>다음</font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="cash:asc">
                                            총보유알 - 오름차순
                                          </option>
                                          <option value="cash:desc">
                                            총보유알 - 내림차순
                                          </option>
                                          <option value="id:asc">
                                            생성일 - 오름차순
                                          </option>
                                          <option value="id:desc">
                                            생성일 - 내림차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner p-0">
                                    <div
                                      className="table-wrapper"
                                      style={{
                                        borderTop: "1px dotted #BBB",
                                        paddingTop: "5px 0",
                                      }}
                                    >
                                      <div className="btn-toolbar justify-content-between">
                                        <div className="btn-group focus-btn-group" />
                                        <div className="btn-group dropdown-btn-group dropdown">
                                          <button
                                            className="btn btn-sm btn-outline-primary"
                                            type="button"
                                          >
                                            모두 보기
                                          </button>
                                          <button
                                            className="btn btn-sm btn-outline-primary dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            id="displayMenuid5fa3e4edf1ca8"
                                            type="button"
                                          >
                                            항목 선택{" "}
                                            <em className="icon ni ni-chevron-down ms-1 me-n1" />
                                          </button>
                                          <ul className="dropdown-menu">
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-0"
                                                id="toggle-id5fa3e4edf1ca8-col-0"
                                                name="toggle-id5fa3e4edf1ca8-col-0"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-0">
                                                트리정보
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-1"
                                                id="toggle-id5fa3e4edf1ca8-col-1"
                                                name="toggle-id5fa3e4edf1ca8-col-1"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-1">
                                                정보
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-2"
                                                id="toggle-id5fa3e4edf1ca8-col-2"
                                                name="toggle-id5fa3e4edf1ca8-col-2"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-2">
                                                결제
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-3"
                                                id="toggle-id5fa3e4edf1ca8-col-3"
                                                name="toggle-id5fa3e4edf1ca8-col-3"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-3">
                                                지갑{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-4"
                                                id="toggle-id5fa3e4edf1ca8-col-4"
                                                name="toggle-id5fa3e4edf1ca8-col-4"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-4">
                                                요율 게임사{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-5"
                                                id="toggle-id5fa3e4edf1ca8-col-5"
                                                name="toggle-id5fa3e4edf1ca8-col-5"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-5">
                                                화폐
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-6"
                                                id="toggle-id5fa3e4edf1ca8-col-6"
                                                name="toggle-id5fa3e4edf1ca8-col-6"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-6">
                                                보유알
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-7"
                                                id="toggle-id5fa3e4edf1ca8-col-7"
                                                name="toggle-id5fa3e4edf1ca8-col-7"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-7">
                                                하부보유알 회원머니{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-8"
                                                id="toggle-id5fa3e4edf1ca8-col-8"
                                                name="toggle-id5fa3e4edf1ca8-col-8"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-8">
                                                총 보유알{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-9"
                                                id="toggle-id5fa3e4edf1ca8-col-9"
                                                name="toggle-id5fa3e4edf1ca8-col-9"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-9">
                                                지급/회수{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-10"
                                                id="toggle-id5fa3e4edf1ca8-col-10"
                                                name="toggle-id5fa3e4edf1ca8-col-10"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-10">
                                                하부 지급/회수{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-11"
                                                id="toggle-id5fa3e4edf1ca8-col-11"
                                                name="toggle-id5fa3e4edf1ca8-col-11"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-11">
                                                회원 지급/회수{" "}
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="id5fa3e4edf1ca8-col-12"
                                                id="toggle-id5fa3e4edf1ca8-col-12"
                                                name="toggle-id5fa3e4edf1ca8-col-12"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-id5fa3e4edf1ca8-col-12">
                                                로그
                                              </label>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div
                                        className="table-responsive"
                                        data-pattern="priority-columns"
                                      >
                                        <div data-pattern="priority-columns">
                                          <table
                                            cellSpacing="0"
                                            className="table table-small-font table-tighten table-bordered table-striped"
                                          >
                                            <thead>
                                              <tr data-pos-y="0">
                                                <th
                                                  className="text-center"
                                                  data-pos-x="0"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-0"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  트리정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="1"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="2"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-2"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  결제
                                                </th>
                                                <th
                                                  className="text-center col-wallet"
                                                  data-bs-original-title="T : 트랜스, S : 심리스, M : 믹스형"
                                                  data-bs-toggle="tooltip"
                                                  data-pos-x="3"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-3"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  지갑{" "}
                                                  <em className="icon ni ni-info-fill vam" />
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="4"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-4"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  요율 <hr />
                                                  <span
                                                    data-bs-original-title="설정된 게임사 수"
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top"
                                                  >
                                                    게임사{" "}
                                                    <em className="icon ni ni-info-fill vam" />
                                                  </span>
                                                </th>
                                                <th
                                                  className="text-center col-currency"
                                                  data-pos-x="5"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-5"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  화폐
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="6"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-6"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  보유알
                                                </th>
                                                <th
                                                  className="rowspan text-center"
                                                  data-pos-x="7"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-7"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span
                                                    data-bs-original-title="하부 에이전트의 총 보유알"
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top"
                                                  >
                                                    하부보유알{" "}
                                                    <em className="icon ni ni-info-fill vam" />
                                                  </span>
                                                  <hr />
                                                  <span
                                                    data-bs-original-title="회원들의 총 보유 머니"
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top"
                                                  >
                                                    회원머니{" "}
                                                    <em className="icon ni ni-info-fill vam" />
                                                  </span>
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="8"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-8"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span
                                                    data-bs-original-title="본인과 하부를 포함한 총 보유알"
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top"
                                                  >
                                                    총 보유알{" "}
                                                    <em className="icon ni ni-info-fill vam" />
                                                  </span>
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="9"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-9"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span
                                                    data-bs-original-title="본인이 상부로부터 지급 받거나 회수된 캐쉬"
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top"
                                                  >
                                                    지급/회수{" "}
                                                    <em className="icon ni ni-info-fill vam" />
                                                  </span>
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="10"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-10"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span
                                                    data-bs-original-title="본인이 하부,회원에게 지급하거나 회수한 캐쉬"
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top"
                                                  >
                                                    하부 지급/회수{" "}
                                                    <em className="icon ni ni-info-fill vam" />
                                                  </span>{" "}
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="11"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-11"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span
                                                    data-bs-original-title="본인이 회원에게 수동 지급하거나 회수한 캐쉬"
                                                    data-bs-toggle="tooltip"
                                                    data-placement="top"
                                                  >
                                                    회원 지급/회수{" "}
                                                    <em className="icon ni ni-info-fill vam" />
                                                  </span>{" "}
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="12"
                                                  data-priority="1"
                                                  id="id5fa3e4edf1ca8-col-12"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  로그
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr data-pos-y="0">
                                                <td
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-0"
                                                  data-org-colspan="1"
                                                  data-pos-x="0"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>
                                                    <em
                                                      className="badge me-1 super"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      Matrixgames
                                                    </em>
                                                  </span>
                                                </td>
                                                <td
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-1"
                                                  data-org-colspan="1"
                                                  data-pos-x="1"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div className="user-toggle">
                                                    <a
                                                      className="dropdown-toggle"
                                                      data-bs-toggle="dropdown"
                                                      href="#"
                                                    >
                                                      <div className="user-toggle">
                                                        <div className="user-info">
                                                          <div className="user-name dropdown-indicator">
                                                            <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                              아이디
                                                            </span>
                                                            Matrixgames
                                                          </div>
                                                          <div className="user-status">
                                                            <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                                              닉네임
                                                            </span>
                                                            Matrixgames
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </a>
                                                    <div
                                                      className="dropdown-menu dropdown-menu-start"
                                                      style={{
                                                        position: "relative",
                                                        zIndex: "999",
                                                      }}
                                                    >
                                                      <ul className="link-check">
                                                        <li>
                                                          <div className="p-1">
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-info me-1">
                                                                지갑
                                                              </span>
                                                              <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                                                S
                                                              </em>
                                                            </div>
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                                아이디
                                                              </span>
                                                              Matrixgames
                                                            </div>
                                                            <div className="user-name">
                                                              <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                                                닉네임
                                                              </span>
                                                              Matrixgames
                                                            </div>
                                                          </div>
                                                        </li>
                                                        <li className="divider" />
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon far fa-copy" />
                                                            <span>
                                                              아이디 복사
                                                            </span>
                                                          </a>
                                                        </li>
                                                        <li className="divider" />
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-info" />
                                                            <span>
                                                              에이전트 정보
                                                            </span>
                                                          </a>
                                                        </li>
                                                        <li className="divider" />
                                                        <li>
                                                          <em className="icon ni ni-plus-c" />
                                                          <span>하부생성</span>
                                                        </li>
                                                        <li className="divider" />
                                                        <li>
                                                          <a href="#">
                                                            <em className="icon ni ni-edit" />
                                                            <span>
                                                              정보수정
                                                            </span>
                                                          </a>
                                                        </li>
                                                        <li className="divider" />
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td
                                                  className="text-center rowspan"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-2"
                                                  data-org-colspan="1"
                                                  data-pos-x="2"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  선불
                                                </td>
                                                <td
                                                  className="text-center rowspan"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-3"
                                                  data-org-colspan="1"
                                                  data-pos-x="3"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                                    S
                                                  </em>
                                                </td>
                                                <td
                                                  className="text-center rowspan"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-4"
                                                  data-org-colspan="1"
                                                  data-pos-x="4"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  0%
                                                  <hr />
                                                  <span
                                                    className="badge rounded-pill bg-gray"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    57
                                                  </span>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-5"
                                                  data-org-colspan="1"
                                                  data-pos-x="5"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  KRW
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-6"
                                                  data-org-colspan="1"
                                                  data-pos-x="6"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                    일반
                                                  </span>
                                                  <strong>
                                                    <span>1,331,989</span>
                                                  </strong>
                                                </td>
                                                <td
                                                  className="text-end rowspan"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-7"
                                                  data-org-colspan="1"
                                                  data-pos-x="7"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <span>269,368,642</span>
                                                  <br />
                                                  <span>0</span>
                                                  <hr />
                                                  <span>0</span>
                                                  <br />
                                                  <span>0</span>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-8"
                                                  data-org-colspan="1"
                                                  data-pos-x="8"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <strong>
                                                    <span>270,700,631</span>
                                                  </strong>
                                                  <hr />
                                                  <strong>
                                                    <span>0</span>
                                                  </strong>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-9"
                                                  data-org-colspan="1"
                                                  data-pos-x="9"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div className="paid-back">
                                                    <span className="paid clearfix">
                                                      <em className="icon ni ni-plus-round-fill" />
                                                      <span>2,297,216,473</span>
                                                    </span>
                                                    <span className="pback">
                                                      <em className="icon ni ni-minus-round-fill" />
                                                      <span>0</span>
                                                    </span>
                                                    <hr />
                                                    <span className="total">
                                                      <em className="icon ni ni-arrow-right-fill-c" />
                                                      <span>2,297,216,473</span>
                                                    </span>
                                                  </div>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-10"
                                                  data-org-colspan="1"
                                                  data-pos-x="10"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div className="paid-back">
                                                    <span className="paid clearfix">
                                                      <em className="icon ni ni-plus-round-fill" />
                                                      <span>618,692,962</span>
                                                    </span>
                                                    <span className="pback">
                                                      <em className="icon ni ni-minus-round-fill" />
                                                      <span>2,851,242,110</span>
                                                    </span>
                                                    <hr />
                                                    <span className="total">
                                                      <em className="icon ni ni-arrow-right-fill-c" />
                                                      <span>2,232,549,148</span>
                                                    </span>
                                                  </div>
                                                </td>
                                                <td
                                                  className="text-end"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-11"
                                                  data-org-colspan="1"
                                                  data-pos-x="11"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div className="paid-back">
                                                    <span className="paid clearfix">
                                                      <em className="icon ni ni-plus-round-fill" />
                                                      <span>0</span>
                                                    </span>
                                                    <span className="pback">
                                                      <em className="icon ni ni-minus-round-fill" />
                                                      <span>0</span>
                                                    </span>
                                                    <hr />
                                                    <span className="total">
                                                      <em className="icon ni ni-arrow-right-fill-c" />
                                                      <span>0</span>
                                                    </span>
                                                  </div>
                                                </td>
                                                <td
                                                  className="text-center"
                                                  colSpan="1"
                                                  data-columns="id5fa3e4edf1ca8-col-12"
                                                  data-org-colspan="1"
                                                  data-pos-x="12"
                                                  data-priority="1"
                                                  style={{
                                                    display: "table-cell",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-secondary badge-date me-1">
                                                        가입일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "95%",
                                                        }}
                                                      >
                                                        2024-09-22
                                                        <font className="dateInHour">
                                                          {" "}
                                                          (16:42:45 UTC +9)
                                                        </font>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <hr className="m-0" />
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-primary badge-date me-1">
                                                        수정일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "95%",
                                                        }}
                                                      >
                                                        2025-04-15
                                                        <font className="dateInHour">
                                                          {" "}
                                                          (10:51:51 UTC +9)
                                                        </font>
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <hr className="m-0" />
                                                  <div
                                                    style={{
                                                      display: "table-row",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span className="small badge badge-dot bg-danger badge-date me-1">
                                                        접속일
                                                      </span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: "table-cell",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          fontSize: "95%",
                                                        }}
                                                      >
                                                        2025-04-21
                                                        <font className="dateInHour">
                                                          {" "}
                                                          (20:54:58 UTC +9)
                                                        </font>
                                                      </span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner">
                                    <div className="row justify-end">
                                      <div className="col-12 col-md-6">
                                        <ul
                                          className="pagination justify-content-center justify-content-md-start"
                                          style={{
                                            float: "right",
                                          }}
                                        >
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font>처음</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font>이전</font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font>다음</font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div className="col-6 col-md-3">
                                        <select className="form-select">
                                          <option value="cash:asc">
                                            총보유알 - 오름차순
                                          </option>
                                          <option value="cash:desc">
                                            총보유알 - 내림차순
                                          </option>
                                          <option value="id:asc">
                                            생성일 - 오름차순
                                          </option>
                                          <option value="id:desc">
                                            생성일 - 내림차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane" id="tb_transaction">
                    <div className="nk-block">
                      <div className="card">
                        <div className="card-inner-group">
                          <div className="card-inner">
                            <div
                              className="nk-block nk-block-lg vTrxsAll"
                              id="opt-x"
                            >
                              <div className="card card-bordered">
                                <div className="card-inner-group">
                                  <div className="card-inner p-3">
                                    <div className="nk-block nk-block-lg">
                                      <form className="mb-0">
                                        <div className="row tbSearch">
                                          <div className="col-sm-12 col-md-12 col-lg-5 col-xl-6 col-xxl-5">
                                            <div className="form-group">
                                              <div className="form-control-wrap raw">
                                                <div className="input-daterange input-group">
                                                  <div className="form-control-wrap">
                                                    <div className="form-icon form-icon-left">
                                                      <em className="icon ni ni-calendar" />
                                                    </div>
                                                    <input
                                                      className="form-control date-picker"
                                                      data-date-format="yyyy-mm-dd"
                                                      id="sdate"
                                                      type="text"
                                                    />
                                                  </div>
                                                  <div className="input-group-addon">
                                                    ~
                                                  </div>
                                                  <div className="form-control-wrap">
                                                    <div className="form-icon form-icon-left">
                                                      <em className="icon ni ni-calendar" />
                                                    </div>
                                                    <input
                                                      className="form-control date-picker"
                                                      data-date-format="yyyy-mm-dd"
                                                      id="edate"
                                                      type="text"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 col-xxl-4">
                                            <div className="form-group">
                                              <div className="form-control-wrap radio-select-day">
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Yesterday"
                                                    name="fv-sex"
                                                    type="radio"
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Yesterday"
                                                  >
                                                    어제
                                                  </label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Today"
                                                    name="fv-sex"
                                                    type="radio"
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Today"
                                                  >
                                                    오늘
                                                  </label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Week"
                                                    name="fv-sex"
                                                    type="radio"
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Week"
                                                  >
                                                    일주일
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-md-6 col-lg-2 col-xl-2 col-xxl-3">
                                            <select className="form-select">
                                              <option value="">지갑</option>
                                              <option value="n">트랜스</option>
                                              <option value="y">심리스</option>
                                              <option value="m">믹스형</option>
                                            </select>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-6 col-sm-6 col-lg-3 col-xl-1 col-xxl-2">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <div
                                                  className="user-toggle intab"
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  <a
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    href="#"
                                                  >
                                                    <div className="user-name dropdown-indicator">
                                                      전체 게임사
                                                    </div>
                                                  </a>
                                                  <div className="dropdown-menu">
                                                    <ul className="nav nav-tabs">
                                                      <li className="nav-item">
                                                        <button
                                                          className="nav-link active"
                                                          data-bs-target="#talb11"
                                                          data-bs-toggle="tab"
                                                          id="home-tab"
                                                          type="button"
                                                        >
                                                          전체
                                                        </button>
                                                      </li>
                                                      <li className="nav-item">
                                                        <button
                                                          className="nav-link"
                                                          data-bs-target="#talb22"
                                                          data-bs-toggle="tab"
                                                          id="profile-tab"
                                                          type="button"
                                                        >
                                                          카지노
                                                        </button>
                                                      </li>
                                                      <li className="nav-item">
                                                        <button
                                                          className="nav-link"
                                                          data-bs-target="#talb44"
                                                          data-bs-toggle="tab"
                                                          id="contact-tab"
                                                          type="button"
                                                        >
                                                          슬롯
                                                        </button>
                                                      </li>
                                                      <li className="nav-item">
                                                        <button
                                                          className="nav-link"
                                                          data-bs-target="#talb55"
                                                          data-bs-toggle="tab"
                                                          id="contact-tab"
                                                          type="button"
                                                        >
                                                          스포츠
                                                        </button>
                                                      </li>
                                                    </ul>
                                                    <div className="tab-content">
                                                      <div
                                                        className="tab-pane show active"
                                                        id="talb11"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        >
                                                          <li value="1">
                                                            <a href="#">
                                                              에볼루션 카지노
                                                            </a>
                                                          </li>
                                                          <li value="20">
                                                            <a href="#">
                                                              드림게이밍
                                                            </a>
                                                          </li>
                                                          <li value="141">
                                                            <a href="#">
                                                              아시안게이밍
                                                              카지노
                                                            </a>
                                                          </li>
                                                          <li value="2">
                                                            <a href="#">
                                                              프라그마틱 카지노
                                                            </a>
                                                          </li>
                                                          <li value="675">
                                                            <a href="#">
                                                              마이크로게이밍
                                                              그랜드 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="200">
                                                            <a href="#">
                                                              마이크로게이밍
                                                              그랜드 카지노
                                                            </a>
                                                          </li>
                                                          <li value="75">
                                                            <a href="#">
                                                              오리엔탈 게이밍
                                                            </a>
                                                          </li>
                                                          <li value="78">
                                                            <a href="#">
                                                              빅게이밍
                                                            </a>
                                                          </li>
                                                          <li value="94">
                                                            <a href="#">
                                                              모티베이션 카지노
                                                            </a>
                                                          </li>
                                                          <li value="32">
                                                            <a href="#">
                                                              이주기
                                                            </a>
                                                          </li>
                                                          <li value="107">
                                                            <a href="#">
                                                              타이산 카지노
                                                            </a>
                                                          </li>
                                                          <li value="114">
                                                            <a href="#">
                                                              스카이윈드 카지노
                                                            </a>
                                                          </li>
                                                          <li value="131">
                                                            <a href="#">
                                                              벳게임즈 TV
                                                            </a>
                                                          </li>
                                                          <li value="180">
                                                            <a href="#">
                                                              섹시 바카라
                                                            </a>
                                                          </li>
                                                          <li value="195">
                                                            <a href="#">
                                                              DB Live 카지노
                                                            </a>
                                                          </li>
                                                          <li value="123">
                                                            <a href="#">
                                                              보타 카지노
                                                            </a>
                                                          </li>
                                                          <li value="3">
                                                            <a href="#">
                                                              프라그마틱 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="142">
                                                            <a href="#">
                                                              아시안게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="6">
                                                            <a href="#">
                                                              하바네로
                                                            </a>
                                                          </li>
                                                          <li value="129">
                                                            <a href="#">
                                                              블루프린트 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="23">
                                                            <a href="#">
                                                              CQ9 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="27">
                                                            <a href="#">
                                                              레드타이거
                                                            </a>
                                                          </li>
                                                          <li value="130">
                                                            <a href="#">
                                                              슬롯 매트릭스
                                                            </a>
                                                          </li>
                                                          <li value="41">
                                                            <a href="#">GMW</a>
                                                          </li>
                                                          <li value="44">
                                                            <a href="#">
                                                              부운고
                                                            </a>
                                                          </li>
                                                          <li value="52">
                                                            <a href="#">
                                                              넷엔트
                                                            </a>
                                                          </li>
                                                          <li value="56">
                                                            <a href="#">BTG</a>
                                                          </li>
                                                          <li value="57">
                                                            <a href="#">
                                                              PG소프트
                                                            </a>
                                                          </li>
                                                          <li value="58">
                                                            <a href="#">
                                                              아스펙트
                                                            </a>
                                                          </li>
                                                          <li value="59">
                                                            <a href="#">
                                                              벳소프트 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="60">
                                                            <a href="#">
                                                              스카이윈드 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="77">
                                                            <a href="#">
                                                              FTG 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="79">
                                                            <a href="#">
                                                              넷게이밍
                                                            </a>
                                                          </li>
                                                          <li value="84">
                                                            <a href="#">
                                                              플레이스타 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="85">
                                                            <a href="#">NAGA</a>
                                                          </li>
                                                          <li value="86">
                                                            <a href="#">
                                                              넥스트스핀 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="87">
                                                            <a href="#">
                                                              플레이앤고
                                                            </a>
                                                          </li>
                                                          <li value="89">
                                                            <a href="#">
                                                              에보플레이 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="91">
                                                            <a href="#">
                                                              아바타UX 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="109">
                                                            <a href="#">
                                                              릴렉스
                                                            </a>
                                                          </li>
                                                          <li value="110">
                                                            <a href="#">
                                                              릴플레이 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="111">
                                                            <a href="#">
                                                              판타즈마 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="112">
                                                            <a href="#">
                                                              부메랑 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="113">
                                                            <a href="#">
                                                              포더플레이어 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="119">
                                                            <a href="#">
                                                              노리밋시티 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="120">
                                                            <a href="#">
                                                              핵쏘우게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="182">
                                                            <a href="#">
                                                              조커 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="186">
                                                            <a href="#">
                                                              JILI 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="132">
                                                            <a href="#">
                                                              펀키게임즈 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="126">
                                                            <a href="#">
                                                              비게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="127">
                                                            <a href="#">
                                                              부밍게임즈 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="128">
                                                            <a href="#">
                                                              익스팬스 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="201">
                                                            <a href="#">
                                                              드래곤소프트
                                                            </a>
                                                          </li>
                                                          <li value="690">
                                                            <a href="#">
                                                              와즈단
                                                            </a>
                                                          </li>
                                                          <li value="688">
                                                            <a href="#">
                                                              옥토플레이
                                                            </a>
                                                          </li>
                                                          <li value="687">
                                                            <a href="#">
                                                              이그드라실
                                                            </a>
                                                          </li>
                                                          <li value="194">
                                                            <a href="#">BT1</a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb22"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        >
                                                          <li value="1">
                                                            <a href="#">
                                                              에볼루션 카지노
                                                            </a>
                                                          </li>
                                                          <li value="20">
                                                            <a href="#">
                                                              드림게이밍
                                                            </a>
                                                          </li>
                                                          <li value="141">
                                                            <a href="#">
                                                              아시안게이밍
                                                              카지노
                                                            </a>
                                                          </li>
                                                          <li value="2">
                                                            <a href="#">
                                                              프라그마틱 카지노
                                                            </a>
                                                          </li>
                                                          <li value="200">
                                                            <a href="#">
                                                              마이크로게이밍
                                                              그랜드 카지노
                                                            </a>
                                                          </li>
                                                          <li value="75">
                                                            <a href="#">
                                                              오리엔탈 게이밍
                                                            </a>
                                                          </li>
                                                          <li value="78">
                                                            <a href="#">
                                                              빅게이밍
                                                            </a>
                                                          </li>
                                                          <li value="94">
                                                            <a href="#">
                                                              모티베이션 카지노
                                                            </a>
                                                          </li>
                                                          <li value="32">
                                                            <a href="#">
                                                              이주기
                                                            </a>
                                                          </li>
                                                          <li value="107">
                                                            <a href="#">
                                                              타이산 카지노
                                                            </a>
                                                          </li>
                                                          <li value="114">
                                                            <a href="#">
                                                              스카이윈드 카지노
                                                            </a>
                                                          </li>
                                                          <li value="131">
                                                            <a href="#">
                                                              벳게임즈 TV
                                                            </a>
                                                          </li>
                                                          <li value="180">
                                                            <a href="#">
                                                              섹시 바카라
                                                            </a>
                                                          </li>
                                                          <li value="195">
                                                            <a href="#">
                                                              DB Live 카지노
                                                            </a>
                                                          </li>
                                                          <li value="123">
                                                            <a href="#">
                                                              보타 카지노
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb44"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        >
                                                          <li value="675">
                                                            <a href="#">
                                                              마이크로게이밍
                                                              그랜드 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="3">
                                                            <a href="#">
                                                              프라그마틱 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="142">
                                                            <a href="#">
                                                              아시안게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="6">
                                                            <a href="#">
                                                              하바네로
                                                            </a>
                                                          </li>
                                                          <li value="129">
                                                            <a href="#">
                                                              블루프린트 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="23">
                                                            <a href="#">
                                                              CQ9 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="27">
                                                            <a href="#">
                                                              레드타이거
                                                            </a>
                                                          </li>
                                                          <li value="130">
                                                            <a href="#">
                                                              슬롯 매트릭스
                                                            </a>
                                                          </li>
                                                          <li value="41">
                                                            <a href="#">GMW</a>
                                                          </li>
                                                          <li value="44">
                                                            <a href="#">
                                                              부운고
                                                            </a>
                                                          </li>
                                                          <li value="52">
                                                            <a href="#">
                                                              넷엔트
                                                            </a>
                                                          </li>
                                                          <li value="56">
                                                            <a href="#">BTG</a>
                                                          </li>
                                                          <li value="57">
                                                            <a href="#">
                                                              PG소프트
                                                            </a>
                                                          </li>
                                                          <li value="58">
                                                            <a href="#">
                                                              아스펙트
                                                            </a>
                                                          </li>
                                                          <li value="59">
                                                            <a href="#">
                                                              벳소프트 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="60">
                                                            <a href="#">
                                                              스카이윈드 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="77">
                                                            <a href="#">
                                                              FTG 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="79">
                                                            <a href="#">
                                                              넷게이밍
                                                            </a>
                                                          </li>
                                                          <li value="84">
                                                            <a href="#">
                                                              플레이스타 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="85">
                                                            <a href="#">NAGA</a>
                                                          </li>
                                                          <li value="86">
                                                            <a href="#">
                                                              넥스트스핀 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="87">
                                                            <a href="#">
                                                              플레이앤고
                                                            </a>
                                                          </li>
                                                          <li value="89">
                                                            <a href="#">
                                                              에보플레이 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="91">
                                                            <a href="#">
                                                              아바타UX 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="109">
                                                            <a href="#">
                                                              릴렉스
                                                            </a>
                                                          </li>
                                                          <li value="110">
                                                            <a href="#">
                                                              릴플레이 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="111">
                                                            <a href="#">
                                                              판타즈마 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="112">
                                                            <a href="#">
                                                              부메랑 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="113">
                                                            <a href="#">
                                                              포더플레이어 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="119">
                                                            <a href="#">
                                                              노리밋시티 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="120">
                                                            <a href="#">
                                                              핵쏘우게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="182">
                                                            <a href="#">
                                                              조커 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="186">
                                                            <a href="#">
                                                              JILI 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="132">
                                                            <a href="#">
                                                              펀키게임즈 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="126">
                                                            <a href="#">
                                                              비게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="127">
                                                            <a href="#">
                                                              부밍게임즈 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="128">
                                                            <a href="#">
                                                              익스팬스 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="201">
                                                            <a href="#">
                                                              드래곤소프트
                                                            </a>
                                                          </li>
                                                          <li value="690">
                                                            <a href="#">
                                                              와즈단
                                                            </a>
                                                          </li>
                                                          <li value="688">
                                                            <a href="#">
                                                              옥토플레이
                                                            </a>
                                                          </li>
                                                          <li value="687">
                                                            <a href="#">
                                                              이그드라실
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb55"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        >
                                                          <li value="194">
                                                            <a href="#">BT1</a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb66"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        />
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb77"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="tab-con-btnset">
                                                      <div className="btn btn-sm btn-block btn-reset">
                                                        <i className="fas fa-redo" />
                                                        초기화
                                                      </div>
                                                      <div className="btn btn-sm btn-block btn-closeTab">
                                                        <i className="far fa-times-circle" />
                                                        닫기
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <label
                                                  className="form-label-outlined"
                                                  htmlFor="outlined-select"
                                                >
                                                  게임사 선택
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-6 col-sm-6 col-lg-3 col-xl-2 col-xxl-2">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <div
                                                  className="user-toggle intab"
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  <a
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    href="#"
                                                  >
                                                    <div className="user-name dropdown-indicator">
                                                      전체 게임형식
                                                    </div>
                                                  </a>
                                                  <div className="dropdown-menu">
                                                    <div className="tab-content">
                                                      <div
                                                        className="tab-pane show active"
                                                        id="talb11"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="tab-con-btnset">
                                                      <div className="btn btn-sm btn-block btn-reset">
                                                        <i className="fas fa-redo" />
                                                        초기화
                                                      </div>
                                                      <div className="btn btn-sm btn-block btn-closeTab">
                                                        <i className="far fa-times-circle" />
                                                        닫기
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <label
                                                  className="form-label-outlined"
                                                  htmlFor="outlined-select"
                                                >
                                                  게임형식 선택
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-6 col-sm-6 col-lg-3 col-xl-2 col-xxl-2">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <div
                                                  className="user-toggle intab"
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  <a
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    href="#"
                                                  >
                                                    <div className="user-name dropdown-indicator">
                                                      게임 선택
                                                    </div>
                                                  </a>
                                                  <div className="dropdown-menu">
                                                    <div className="tab-content">
                                                      <div
                                                        className="tab-pane show active"
                                                        id="talb11"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="tab-con-btnset">
                                                      <div className="btn btn-sm btn-block btn-reset">
                                                        <i className="fas fa-redo" />
                                                        초기화
                                                      </div>
                                                      <div className="btn btn-sm btn-block btn-closeTab">
                                                        <i className="far fa-times-circle" />
                                                        닫기
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <label
                                                  className="form-label-outlined"
                                                  htmlFor="outlined-select"
                                                >
                                                  게임 선택
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-6 col-sm-6 col-lg-3 col-xl-2 col-xxl-2">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <select
                                                  className="form-select js-select2"
                                                  id="seachType"
                                                  onchange="window.CommBetSearch.gameTypeChange(this)"
                                                >
                                                  <option value="all">
                                                    ==전체==
                                                  </option>
                                                  <optgroup label="베팅내역">
                                                    <option value="turn_bet">
                                                      베팅
                                                    </option>
                                                    <option value="turn_win">
                                                      승
                                                    </option>
                                                    <option value="turn_draw">
                                                      무
                                                    </option>
                                                    <option value="turn_lose">
                                                      패
                                                    </option>
                                                    <option value="turn_cancel">
                                                      취소
                                                    </option>
                                                    <option value="turn_adjust">
                                                      조정
                                                    </option>
                                                  </optgroup>
                                                  <optgroup label="게임 거래 내역">
                                                    <option value="op_to_mb">
                                                      입금
                                                    </option>
                                                    <option value="mb_to_op">
                                                      출금
                                                    </option>
                                                    <option value="turn_in">
                                                      게임입금
                                                    </option>
                                                    <option value="turn_out">
                                                      게임출금
                                                    </option>
                                                    <option value="in_game">
                                                      게임입장
                                                    </option>
                                                  </optgroup>
                                                  <optgroup label="관리자 지급/회수">
                                                    <option value="admdeposit">
                                                      관리자 지급
                                                    </option>
                                                    <option value="admwithdraw">
                                                      관리자 회수
                                                    </option>
                                                  </optgroup>
                                                  <optgroup label="상부 지급/회수">
                                                    <option value="updeposit">
                                                      상부가 지급
                                                    </option>
                                                    <option value="upwithdraw">
                                                      상부가 회수
                                                    </option>
                                                  </optgroup>
                                                  <optgroup label="하부 지급/회수">
                                                    <option value="downdeposit">
                                                      하부에 지급
                                                    </option>
                                                    <option value="downwithdraw">
                                                      하부를 회수
                                                    </option>
                                                  </optgroup>
                                                  <optgroup label="회원 수동 지급/회수">
                                                    <option value="cash_in">
                                                      회원 수동 지급
                                                    </option>
                                                    <option value="cash_out">
                                                      회원 수동 회수
                                                    </option>
                                                  </optgroup>
                                                  <optgroup label="초과 당첨금 회수">
                                                    <option value="updepositCash">
                                                      초과 당첨금
                                                    </option>
                                                  </optgroup>
                                                </select>
                                                <label
                                                  className="form-label-outlined"
                                                  htmlFor="outlined-select"
                                                >
                                                  트랜젝션
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-12 col-sm-6 col-lg-6 col-xl-3 col-xxl-4">
                                            <div className="form-control-wrap">
                                              <button
                                                className="btn btn-outline-primary btn-dim"
                                                type="submit"
                                              >
                                                <em className="icon ni ni-search me-2" />{" "}
                                                검색
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                  <div className="card-inner p-3 cpaginationMongo">
                                    <div className="pnavi_wrap_flex">
                                      <div>
                                        <ul className="pagination justify-content-center justify-content-md-start">
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font className="d-lg-none d-xl-block">
                                                처음
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font className="d-lg-none d-xl-block">
                                                이전
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item input">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font className="d-lg-none d-xl-block">
                                                다음
                                              </font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="-1">
                                            처리시간 - 내림차순
                                          </option>
                                          <option value="1">
                                            처리시간 - 오름차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner tableBox p-0">
                                    <div className="table-responsive">
                                      <div>
                                        <table
                                          cellSpacing="0"
                                          className="table table-small-font table-tighten table-bordered table-striped"
                                        >
                                          <thead>
                                            <tr>
                                              <th className="text-center col-detail">
                                                상세
                                              </th>
                                              <th className="text-center">
                                                트리정보
                                              </th>
                                              <th className="text-center">
                                                소속 에이전트
                                              </th>
                                              <th className="text-center">
                                                정보
                                              </th>
                                              <th className="text-center">
                                                게임정보
                                              </th>
                                              <th className="text-center">
                                                거래방식
                                              </th>
                                              <th className="text-center col-currency">
                                                화폐
                                              </th>
                                              <th className="text-center">
                                                이전
                                              </th>
                                              <th className="text-center">
                                                금액
                                              </th>
                                              <th className="text-center">
                                                이후
                                              </th>
                                              <th className="text-center">
                                                처리시간
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <td
                                                className="text-center span-cell-emt"
                                                colSpan="14"
                                              >
                                                <div className="nk-order-ovwg-ck text-red">
                                                  <h5>
                                                    조회된 정보가 없습니다.
                                                  </h5>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner p-3 cpaginationMongo">
                                    <div className="pnavi_wrap_flex">
                                      <div>
                                        <ul className="pagination justify-content-center justify-content-md-start">
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font className="d-lg-none d-xl-block">
                                                처음
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font className="d-lg-none d-xl-block">
                                                이전
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item input">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font className="d-lg-none d-xl-block">
                                                다음
                                              </font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="-1">
                                            처리시간 - 내림차순
                                          </option>
                                          <option value="1">
                                            처리시간 - 오름차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane" id="tb_bet">
                    <div className="nk-block">
                      <div className="card">
                        <div className="card-inner-group">
                          <div className="card-inner">
                            <div
                              className="nk-block vLogsBettingCurrency"
                              id="opt-x"
                            >
                              <div className="card card-bordered">
                                <div className="card-inner-group">
                                  <div className="card-inner p-3">
                                    <div className="nk-block nk-block-lg">
                                      <form className="mb-0">
                                        <div className="row tbSearch">
                                          <div className="col-sm-12 col-md-12 col-lg-5 col-xl-6 col-xxl-5">
                                            <div className="form-group">
                                              <div className="form-control-wrap raw">
                                                <div className="input-daterange input-group">
                                                  <div className="form-control-wrap">
                                                    <div className="form-icon form-icon-left">
                                                      <em className="icon ni ni-calendar" />
                                                    </div>
                                                    <input
                                                      className="form-control date-picker"
                                                      data-date-format="yyyy-mm-dd"
                                                      id="sdate"
                                                      type="text"
                                                    />
                                                  </div>
                                                  <div className="input-group-addon">
                                                    ~
                                                  </div>
                                                  <div className="form-control-wrap">
                                                    <div className="form-icon form-icon-left">
                                                      <em className="icon ni ni-calendar" />
                                                    </div>
                                                    <input
                                                      className="form-control date-picker"
                                                      data-date-format="yyyy-mm-dd"
                                                      id="edate"
                                                      type="text"
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 col-xxl-4">
                                            <div className="form-group">
                                              <div className="form-control-wrap radio-select-day">
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Yesterday"
                                                    name="fv-sex"
                                                    type="radio"
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Yesterday"
                                                  >
                                                    어제
                                                  </label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Today"
                                                    name="fv-sex"
                                                    type="radio"
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Today"
                                                  >
                                                    오늘
                                                  </label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Week"
                                                    name="fv-sex"
                                                    type="radio"
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Week"
                                                  >
                                                    일주일
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-md-6 col-lg-2 col-xl-2 col-xxl-3">
                                            <select className="form-select">
                                              <option value="">지갑</option>
                                              <option value="n">트랜스</option>
                                              <option value="y">심리스</option>
                                              <option value="m">믹스형</option>
                                            </select>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-6 col-sm-6 col-lg-3 col-xl-1 col-xxl-2">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <div
                                                  className="user-toggle intab"
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  <a
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    href="#"
                                                  >
                                                    <div className="user-name dropdown-indicator">
                                                      전체 게임사
                                                    </div>
                                                  </a>
                                                  <div className="dropdown-menu">
                                                    <ul className="nav nav-tabs">
                                                      <li className="nav-item">
                                                        <button
                                                          className="nav-link active"
                                                          data-bs-target="#talb11"
                                                          data-bs-toggle="tab"
                                                          id="home-tab"
                                                          type="button"
                                                        >
                                                          전체
                                                        </button>
                                                      </li>
                                                      <li className="nav-item">
                                                        <button
                                                          className="nav-link"
                                                          data-bs-target="#talb22"
                                                          data-bs-toggle="tab"
                                                          id="profile-tab"
                                                          type="button"
                                                        >
                                                          카지노
                                                        </button>
                                                      </li>
                                                      <li className="nav-item">
                                                        <button
                                                          className="nav-link"
                                                          data-bs-target="#talb44"
                                                          data-bs-toggle="tab"
                                                          id="contact-tab"
                                                          type="button"
                                                        >
                                                          슬롯
                                                        </button>
                                                      </li>
                                                      <li className="nav-item">
                                                        <button
                                                          className="nav-link"
                                                          data-bs-target="#talb55"
                                                          data-bs-toggle="tab"
                                                          id="contact-tab"
                                                          type="button"
                                                        >
                                                          스포츠
                                                        </button>
                                                      </li>
                                                    </ul>
                                                    <div className="tab-content">
                                                      <div
                                                        className="tab-pane show active"
                                                        id="talb11"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        >
                                                          <li value="1">
                                                            <a href="#">
                                                              에볼루션 카지노
                                                            </a>
                                                          </li>
                                                          <li value="20">
                                                            <a href="#">
                                                              드림게이밍
                                                            </a>
                                                          </li>
                                                          <li value="141">
                                                            <a href="#">
                                                              아시안게이밍
                                                              카지노
                                                            </a>
                                                          </li>
                                                          <li value="2">
                                                            <a href="#">
                                                              프라그마틱 카지노
                                                            </a>
                                                          </li>
                                                          <li value="675">
                                                            <a href="#">
                                                              마이크로게이밍
                                                              그랜드 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="200">
                                                            <a href="#">
                                                              마이크로게이밍
                                                              그랜드 카지노
                                                            </a>
                                                          </li>
                                                          <li value="75">
                                                            <a href="#">
                                                              오리엔탈 게이밍
                                                            </a>
                                                          </li>
                                                          <li value="78">
                                                            <a href="#">
                                                              빅게이밍
                                                            </a>
                                                          </li>
                                                          <li value="94">
                                                            <a href="#">
                                                              모티베이션 카지노
                                                            </a>
                                                          </li>
                                                          <li value="32">
                                                            <a href="#">
                                                              이주기
                                                            </a>
                                                          </li>
                                                          <li value="107">
                                                            <a href="#">
                                                              타이산 카지노
                                                            </a>
                                                          </li>
                                                          <li value="114">
                                                            <a href="#">
                                                              스카이윈드 카지노
                                                            </a>
                                                          </li>
                                                          <li value="131">
                                                            <a href="#">
                                                              벳게임즈 TV
                                                            </a>
                                                          </li>
                                                          <li value="180">
                                                            <a href="#">
                                                              섹시 바카라
                                                            </a>
                                                          </li>
                                                          <li value="195">
                                                            <a href="#">
                                                              DB Live 카지노
                                                            </a>
                                                          </li>
                                                          <li value="123">
                                                            <a href="#">
                                                              보타 카지노
                                                            </a>
                                                          </li>
                                                          <li value="3">
                                                            <a href="#">
                                                              프라그마틱 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="142">
                                                            <a href="#">
                                                              아시안게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="6">
                                                            <a href="#">
                                                              하바네로
                                                            </a>
                                                          </li>
                                                          <li value="129">
                                                            <a href="#">
                                                              블루프린트 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="23">
                                                            <a href="#">
                                                              CQ9 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="27">
                                                            <a href="#">
                                                              레드타이거
                                                            </a>
                                                          </li>
                                                          <li value="130">
                                                            <a href="#">
                                                              슬롯 매트릭스
                                                            </a>
                                                          </li>
                                                          <li value="41">
                                                            <a href="#">GMW</a>
                                                          </li>
                                                          <li value="44">
                                                            <a href="#">
                                                              부운고
                                                            </a>
                                                          </li>
                                                          <li value="52">
                                                            <a href="#">
                                                              넷엔트
                                                            </a>
                                                          </li>
                                                          <li value="56">
                                                            <a href="#">BTG</a>
                                                          </li>
                                                          <li value="57">
                                                            <a href="#">
                                                              PG소프트
                                                            </a>
                                                          </li>
                                                          <li value="58">
                                                            <a href="#">
                                                              아스펙트
                                                            </a>
                                                          </li>
                                                          <li value="59">
                                                            <a href="#">
                                                              벳소프트 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="60">
                                                            <a href="#">
                                                              스카이윈드 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="77">
                                                            <a href="#">
                                                              FTG 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="79">
                                                            <a href="#">
                                                              넷게이밍
                                                            </a>
                                                          </li>
                                                          <li value="84">
                                                            <a href="#">
                                                              플레이스타 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="85">
                                                            <a href="#">NAGA</a>
                                                          </li>
                                                          <li value="86">
                                                            <a href="#">
                                                              넥스트스핀 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="87">
                                                            <a href="#">
                                                              플레이앤고
                                                            </a>
                                                          </li>
                                                          <li value="89">
                                                            <a href="#">
                                                              에보플레이 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="91">
                                                            <a href="#">
                                                              아바타UX 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="109">
                                                            <a href="#">
                                                              릴렉스
                                                            </a>
                                                          </li>
                                                          <li value="110">
                                                            <a href="#">
                                                              릴플레이 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="111">
                                                            <a href="#">
                                                              판타즈마 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="112">
                                                            <a href="#">
                                                              부메랑 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="113">
                                                            <a href="#">
                                                              포더플레이어 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="119">
                                                            <a href="#">
                                                              노리밋시티 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="120">
                                                            <a href="#">
                                                              핵쏘우게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="182">
                                                            <a href="#">
                                                              조커 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="186">
                                                            <a href="#">
                                                              JILI 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="132">
                                                            <a href="#">
                                                              펀키게임즈 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="126">
                                                            <a href="#">
                                                              비게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="127">
                                                            <a href="#">
                                                              부밍게임즈 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="128">
                                                            <a href="#">
                                                              익스팬스 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="201">
                                                            <a href="#">
                                                              드래곤소프트
                                                            </a>
                                                          </li>
                                                          <li value="690">
                                                            <a href="#">
                                                              와즈단
                                                            </a>
                                                          </li>
                                                          <li value="688">
                                                            <a href="#">
                                                              옥토플레이
                                                            </a>
                                                          </li>
                                                          <li value="687">
                                                            <a href="#">
                                                              이그드라실
                                                            </a>
                                                          </li>
                                                          <li value="194">
                                                            <a href="#">BT1</a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb22"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        >
                                                          <li value="1">
                                                            <a href="#">
                                                              에볼루션 카지노
                                                            </a>
                                                          </li>
                                                          <li value="20">
                                                            <a href="#">
                                                              드림게이밍
                                                            </a>
                                                          </li>
                                                          <li value="141">
                                                            <a href="#">
                                                              아시안게이밍
                                                              카지노
                                                            </a>
                                                          </li>
                                                          <li value="2">
                                                            <a href="#">
                                                              프라그마틱 카지노
                                                            </a>
                                                          </li>
                                                          <li value="200">
                                                            <a href="#">
                                                              마이크로게이밍
                                                              그랜드 카지노
                                                            </a>
                                                          </li>
                                                          <li value="75">
                                                            <a href="#">
                                                              오리엔탈 게이밍
                                                            </a>
                                                          </li>
                                                          <li value="78">
                                                            <a href="#">
                                                              빅게이밍
                                                            </a>
                                                          </li>
                                                          <li value="94">
                                                            <a href="#">
                                                              모티베이션 카지노
                                                            </a>
                                                          </li>
                                                          <li value="32">
                                                            <a href="#">
                                                              이주기
                                                            </a>
                                                          </li>
                                                          <li value="107">
                                                            <a href="#">
                                                              타이산 카지노
                                                            </a>
                                                          </li>
                                                          <li value="114">
                                                            <a href="#">
                                                              스카이윈드 카지노
                                                            </a>
                                                          </li>
                                                          <li value="131">
                                                            <a href="#">
                                                              벳게임즈 TV
                                                            </a>
                                                          </li>
                                                          <li value="180">
                                                            <a href="#">
                                                              섹시 바카라
                                                            </a>
                                                          </li>
                                                          <li value="195">
                                                            <a href="#">
                                                              DB Live 카지노
                                                            </a>
                                                          </li>
                                                          <li value="123">
                                                            <a href="#">
                                                              보타 카지노
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb44"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        >
                                                          <li value="675">
                                                            <a href="#">
                                                              마이크로게이밍
                                                              그랜드 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="3">
                                                            <a href="#">
                                                              프라그마틱 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="142">
                                                            <a href="#">
                                                              아시안게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="6">
                                                            <a href="#">
                                                              하바네로
                                                            </a>
                                                          </li>
                                                          <li value="129">
                                                            <a href="#">
                                                              블루프린트 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="23">
                                                            <a href="#">
                                                              CQ9 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="27">
                                                            <a href="#">
                                                              레드타이거
                                                            </a>
                                                          </li>
                                                          <li value="130">
                                                            <a href="#">
                                                              슬롯 매트릭스
                                                            </a>
                                                          </li>
                                                          <li value="41">
                                                            <a href="#">GMW</a>
                                                          </li>
                                                          <li value="44">
                                                            <a href="#">
                                                              부운고
                                                            </a>
                                                          </li>
                                                          <li value="52">
                                                            <a href="#">
                                                              넷엔트
                                                            </a>
                                                          </li>
                                                          <li value="56">
                                                            <a href="#">BTG</a>
                                                          </li>
                                                          <li value="57">
                                                            <a href="#">
                                                              PG소프트
                                                            </a>
                                                          </li>
                                                          <li value="58">
                                                            <a href="#">
                                                              아스펙트
                                                            </a>
                                                          </li>
                                                          <li value="59">
                                                            <a href="#">
                                                              벳소프트 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="60">
                                                            <a href="#">
                                                              스카이윈드 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="77">
                                                            <a href="#">
                                                              FTG 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="79">
                                                            <a href="#">
                                                              넷게이밍
                                                            </a>
                                                          </li>
                                                          <li value="84">
                                                            <a href="#">
                                                              플레이스타 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="85">
                                                            <a href="#">NAGA</a>
                                                          </li>
                                                          <li value="86">
                                                            <a href="#">
                                                              넥스트스핀 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="87">
                                                            <a href="#">
                                                              플레이앤고
                                                            </a>
                                                          </li>
                                                          <li value="89">
                                                            <a href="#">
                                                              에보플레이 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="91">
                                                            <a href="#">
                                                              아바타UX 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="109">
                                                            <a href="#">
                                                              릴렉스
                                                            </a>
                                                          </li>
                                                          <li value="110">
                                                            <a href="#">
                                                              릴플레이 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="111">
                                                            <a href="#">
                                                              판타즈마 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="112">
                                                            <a href="#">
                                                              부메랑 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="113">
                                                            <a href="#">
                                                              포더플레이어 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="119">
                                                            <a href="#">
                                                              노리밋시티 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="120">
                                                            <a href="#">
                                                              핵쏘우게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="182">
                                                            <a href="#">
                                                              조커 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="186">
                                                            <a href="#">
                                                              JILI 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="132">
                                                            <a href="#">
                                                              펀키게임즈 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="126">
                                                            <a href="#">
                                                              비게이밍 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="127">
                                                            <a href="#">
                                                              부밍게임즈 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="128">
                                                            <a href="#">
                                                              익스팬스 슬롯
                                                            </a>
                                                          </li>
                                                          <li value="201">
                                                            <a href="#">
                                                              드래곤소프트
                                                            </a>
                                                          </li>
                                                          <li value="690">
                                                            <a href="#">
                                                              와즈단
                                                            </a>
                                                          </li>
                                                          <li value="688">
                                                            <a href="#">
                                                              옥토플레이
                                                            </a>
                                                          </li>
                                                          <li value="687">
                                                            <a href="#">
                                                              이그드라실
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb55"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        >
                                                          <li value="194">
                                                            <a href="#">BT1</a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb66"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        />
                                                      </div>
                                                      <div
                                                        className="tab-pane"
                                                        id="talb77"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="tab-con-btnset">
                                                      <div className="btn btn-sm btn-block btn-reset">
                                                        <i className="fas fa-redo" />
                                                        초기화
                                                      </div>
                                                      <div className="btn btn-sm btn-block btn-closeTab">
                                                        <i className="far fa-times-circle" />
                                                        닫기
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <label
                                                  className="form-label-outlined"
                                                  htmlFor="outlined-select"
                                                >
                                                  게임사 선택
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-6 col-sm-6 col-lg-3 col-xl-2 col-xxl-2">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <div
                                                  className="user-toggle intab"
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  <a
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    href="#"
                                                  >
                                                    <div className="user-name dropdown-indicator">
                                                      전체 게임형식
                                                    </div>
                                                  </a>
                                                  <div className="dropdown-menu">
                                                    <div className="tab-content">
                                                      <div
                                                        className="tab-pane show active"
                                                        id="talb11"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="tab-con-btnset">
                                                      <div className="btn btn-sm btn-block btn-reset">
                                                        <i className="fas fa-redo" />
                                                        초기화
                                                      </div>
                                                      <div className="btn btn-sm btn-block btn-closeTab">
                                                        <i className="far fa-times-circle" />
                                                        닫기
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <label
                                                  className="form-label-outlined"
                                                  htmlFor="outlined-select"
                                                >
                                                  게임형식 선택
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-6 col-sm-6 col-lg-3 col-xl-2 col-xxl-2">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <div
                                                  className="user-toggle intab"
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  <a
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    href="#"
                                                  >
                                                    <div className="user-name dropdown-indicator">
                                                      게임 선택
                                                    </div>
                                                  </a>
                                                  <div className="dropdown-menu">
                                                    <div className="tab-content">
                                                      <div
                                                        className="tab-pane show active"
                                                        id="talb11"
                                                      >
                                                        <div className="input-group">
                                                          <input
                                                            className="form-control"
                                                            type="text"
                                                          />
                                                        </div>
                                                        <ul
                                                          className="link-check"
                                                          style={{
                                                            height: "300px",
                                                            overflow: "auto",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="tab-con-btnset">
                                                      <div className="btn btn-sm btn-block btn-reset">
                                                        <i className="fas fa-redo" />
                                                        초기화
                                                      </div>
                                                      <div className="btn btn-sm btn-block btn-closeTab">
                                                        <i className="far fa-times-circle" />
                                                        닫기
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <label
                                                  className="form-label-outlined"
                                                  htmlFor="outlined-select"
                                                >
                                                  게임 선택
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-6 col-sm-6 col-lg-3 col-xl-2 col-xxl-1">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <select
                                                  className="form-select js-select2"
                                                  id="seachType"
                                                  onchange="window.CommBetSearch.gameTypeChange(this)"
                                                >
                                                  <option value="all">
                                                    ==전체==
                                                  </option>
                                                  <optgroup label="베팅내역">
                                                    <option value="turn_bet">
                                                      베팅
                                                    </option>
                                                    <option value="turn_win">
                                                      승
                                                    </option>
                                                    <option value="turn_draw">
                                                      무
                                                    </option>
                                                    <option value="turn_lose">
                                                      패
                                                    </option>
                                                    <option value="turn_cancel">
                                                      취소
                                                    </option>
                                                    <option value="turn_in">
                                                      게임입금
                                                    </option>
                                                    <option value="turn_out">
                                                      게임출금
                                                    </option>
                                                  </optgroup>
                                                  <optgroup label="초과 당첨금 회수">
                                                    <option value="updepositCash">
                                                      초과 당첨금
                                                    </option>
                                                  </optgroup>
                                                </select>
                                                <label
                                                  className="form-label-outlined"
                                                  htmlFor="outlined-select"
                                                >
                                                  트랜젝션
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-12 col-sm-6 col-lg-6 col-xl-3 col-xxl-3">
                                            <div className="form-control-wrap">
                                              <button
                                                className="btn btn-outline-primary btn-dim"
                                                type="submit"
                                              >
                                                <em className="icon ni ni-search me-2" />{" "}
                                                검색
                                              </button>
                                            </div>
                                          </div>
                                          <div className="col-12 col-sm-6 col-lg-6 col-xl-2 col-xxl-2">
                                            <div className="input-group">
                                              <div className="input-group-prepend">
                                                <div className="btn btn-primary">
                                                  <em className="icon ni ni-sign-usd-alt me-1" />
                                                  <font>베팅 당첨금</font>
                                                </div>
                                              </div>
                                              <input
                                                className="form-control"
                                                placeholder="베팅 당첨금"
                                                type="number"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                  <div className="card-inner p-3 cpaginationMongo">
                                    <div className="pnavi_wrap_flex">
                                      <div>
                                        <ul className="pagination justify-content-center justify-content-md-start">
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font className="d-lg-none d-xl-block">
                                                처음
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font className="d-lg-none d-xl-block">
                                                이전
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item input">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font className="d-lg-none d-xl-block">
                                                다음
                                              </font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="-1">
                                            베팅시간 - 내림차순
                                          </option>
                                          <option value="1">
                                            베팅시간 - 오름차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner tableBox p-0">
                                    <div
                                      className="table-wrapper"
                                      style={{
                                        borderTop: "1px dotted #BBB",
                                        paddingTop: "5px 0",
                                      }}
                                    >
                                      <div className="btn-toolbar justify-content-between">
                                        <div className="btn-group focus-btn-group" />
                                        <div className="btn-group dropdown-btn-group dropdown">
                                          <button
                                            className="btn btn-sm btn-outline-primary"
                                            type="button"
                                          >
                                            모두 보기
                                          </button>
                                          <button
                                            className="btn btn-sm btn-outline-primary dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            id="displayMenuidf60eb3d4dde28"
                                            type="button"
                                          >
                                            항목 선택{" "}
                                            <em className="icon ni ni-chevron-down ms-1 me-n1" />
                                          </button>
                                          <ul className="dropdown-menu">
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-0"
                                                id="toggle-idf60eb3d4dde28-col-0"
                                                name="toggle-idf60eb3d4dde28-col-0"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-0">
                                                상세
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-1"
                                                id="toggle-idf60eb3d4dde28-col-1"
                                                name="toggle-idf60eb3d4dde28-col-1"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-1">
                                                트리정보
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-2"
                                                id="toggle-idf60eb3d4dde28-col-2"
                                                name="toggle-idf60eb3d4dde28-col-2"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-2">
                                                정보
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-3"
                                                id="toggle-idf60eb3d4dde28-col-3"
                                                name="toggle-idf60eb3d4dde28-col-3"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-3">
                                                게임
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-4"
                                                id="toggle-idf60eb3d4dde28-col-4"
                                                name="toggle-idf60eb3d4dde28-col-4"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-4">
                                                화폐
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-5"
                                                id="toggle-idf60eb3d4dde28-col-5"
                                                name="toggle-idf60eb3d4dde28-col-5"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-5">
                                                베팅정보
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-6"
                                                id="toggle-idf60eb3d4dde28-col-6"
                                                name="toggle-idf60eb3d4dde28-col-6"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-6">
                                                처리정보
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-7"
                                                id="toggle-idf60eb3d4dde28-col-7"
                                                name="toggle-idf60eb3d4dde28-col-7"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-7">
                                                유저베팅
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-8"
                                                id="toggle-idf60eb3d4dde28-col-8"
                                                name="toggle-idf60eb3d4dde28-col-8"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-8">
                                                게임결과
                                              </label>
                                            </li>
                                            <li className="checkbox-row">
                                              <input
                                                defaultValue="idf60eb3d4dde28-col-9"
                                                id="toggle-idf60eb3d4dde28-col-9"
                                                name="toggle-idf60eb3d4dde28-col-9"
                                                type="checkbox"
                                              />
                                              <label htmlFor="toggle-idf60eb3d4dde28-col-9">
                                                처리시간
                                              </label>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div className="table-responsive">
                                        <div>
                                          <table
                                            cellSpacing="0"
                                            className="table table-small-font table-tighten table-bordered table-striped navbar-fixed-top"
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  className="text-center col-detail"
                                                  data-pos-x="0"
                                                  id="idf60eb3d4dde28-col-0"
                                                >
                                                  상세
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="1"
                                                  id="idf60eb3d4dde28-col-1"
                                                >
                                                  트리정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="2"
                                                  id="idf60eb3d4dde28-col-2"
                                                >
                                                  정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="3"
                                                  id="idf60eb3d4dde28-col-3"
                                                >
                                                  게임
                                                </th>
                                                <th
                                                  className="text-center col-currency"
                                                  data-pos-x="4"
                                                  id="idf60eb3d4dde28-col-4"
                                                >
                                                  화폐
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="5"
                                                  id="idf60eb3d4dde28-col-5"
                                                >
                                                  베팅정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="6"
                                                  id="idf60eb3d4dde28-col-6"
                                                >
                                                  처리정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="7"
                                                  id="idf60eb3d4dde28-col-7"
                                                >
                                                  유저베팅
                                                </th>
                                                <th
                                                  className="text-center col-rsdata"
                                                  data-pos-x="8"
                                                  id="idf60eb3d4dde28-col-8"
                                                >
                                                  게임결과
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="9"
                                                  id="idf60eb3d4dde28-col-9"
                                                >
                                                  처리시간
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td
                                                  className="text-center span-cell-emt spn-cell"
                                                  colSpan="14"
                                                >
                                                  <div className="nk-order-ovwg-ck text-red">
                                                    <h5>
                                                      조회된 정보가 없습니다.
                                                    </h5>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner p-3 cpaginationMongo">
                                    <div className="pnavi_wrap_flex">
                                      <div>
                                        <ul className="pagination justify-content-center justify-content-md-start">
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font className="d-lg-none d-xl-block">
                                                처음
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font className="d-lg-none d-xl-block">
                                                이전
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item input">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font className="d-lg-none d-xl-block">
                                                다음
                                              </font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="-1">
                                            처리시간 - 내림차순
                                          </option>
                                          <option value="1">
                                            처리시간 - 오름차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
}
